// This file is auto-generated by @hey-api/openapi-ts

export {
    deleteAdminBillingCreditCostsId,
    deleteAdminBillingPlansId,
    deleteAssessmentParamsId,
    deleteAssessmentTemplatesId,
    deleteCandidatesId,
    deleteCompanyCompanySlugApprovalFlowRuleId,
    deleteCompanyCompanySlugCandidateStatusesConfigStatusId,
    deleteCompanyCompanySlugDepartments,
    deleteCustomAnalyticsDashboard,
    deleteCustomAnalyticsId,
    deleteHiringManagersId,
    deleteInterviewsId,
    deleteInterviewsIdInterviewRoundInterviewRoundId,
    deleteInterviewsIdInterviewRoundInterviewRoundIdPanellist,
    deleteInterviewsScreeningCall,
    deleteInterviewsScreeningInterviewClientTokenId,
    deleteInterviewsScreeningInterviewIdentityCheckId,
    deleteInterviewsScreeningInterviewSpeechTokenId,
    deleteJdId,
    deleteJobApplicationsId,
    deleteJobsId,
    deleteJobsIdSourcedCandidatesSourcedCandidateId,
    deleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteId,
    deleteMarleeSessionSessionId,
    deleteNotesId,
    deleteNotificationsId,
    deleteSettingsCommunicationTemplatesId,
    getAdminBillingCreditCosts,
    getAdminBillingCreditCostsExport,
    getAdminBillingCreditCostsId,
    getAdminBillingPlans,
    getAdminBillingPlansExport,
    getAdminBillingPlansId,
    getAdminBillingSignupDrafts,
    getAdminCompanies,
    getAdminCompaniesId,
    getAdminCompaniesIdAccessControl,
    getAdminCompaniesIdCredits,
    getAdminCompaniesIdCreditsLedger,
    getAdminCompaniesIdIntegrations,
    getAdminIntalentUsers,
    getAdminInterviewQualityReports,
    getAdminInterviewQualityReportsId,
    getAdminInterviewQualityRuns,
    getApplicationsSearch,
    getAssessmentParams,
    getAssessmentParamsId,
    getAssessmentTemplates,
    getAssessmentTemplatesId,
    getAuthLogoutCallback,
    getAuthMyCompanies,
    getAuthProfile,
    getAuthSwitchCompany,
    getBillingPlans,
    getBillingSubscription,
    getBillingUsage,
    getCandidates,
    getCandidateSharingSharingSlug,
    getCandidatesId,
    getChatbotConfig,
    getCommunicationStatusEmailClientId,
    getCompany,
    getCompanyCompanySlugAccessControlConfig,
    getCompanyCompanySlugApprovalFlow,
    getCompanyCompanySlugCandidateStatusesConfig,
    getCompanyCompanySlugDepartments,
    getCompanyCompanySlugIntegrations,
    getCompanyCompanySlugJdTemplate,
    getCompanyCompanySlugJobPostingConfig,
    getCompanyCompanySlugPanellists,
    getCompanyCompanySlugScreeningWebrtcConfig,
    getCompanyCompanySlugUsers,
    getCompanyConfig,
    getCompanyDepartments,
    getCompanyEmploymentTypes,
    getCompanySlugJobsJobPostingIdTalentPoolInvites,
    getCompanySlugPublicCareerConfig,
    getCompanySlugPublicCareerDepartments,
    getCompanySlugPublicCareerJobs,
    getCompanySlugPublicCareerJobsId,
    getCompanySlugPublicCareerJobsIdUploadUrl,
    getCompanySlugPublicCareerTalentPoolUploadUrl,
    getCronAiInterviewReminders,
    getCronFeedbackReminders,
    getCronRenewCalendarSubscriptions,
    getCronScreeningWebrtcLifecycleSweeper,
    getCustomAnalytics,
    getEmbeddings,
    getHiringManagers,
    getIntegrationsGoogleAuthorize,
    getIntegrationsGoogleCallback,
    getIntegrationsMicrosoftAuthorize,
    getIntegrationsMicrosoftCallback,
    getInternalSttToken,
    getInterviews,
    getInterviewsFeedback,
    getInterviewsFeedbackTranscript,
    getInterviewsId,
    getInterviewsScreeningCallIdRecording,
    getInterviewsScreeningInterview,
    getInterviewsScreeningInterviewCandidate,
    getInterviewsScreeningInterviewClientToken,
    getInterviewsScreeningInterviewIceServers,
    getInterviewsScreeningInterviewIdentityCheckId,
    getInterviewsScreeningInterviewProctoring,
    getInterviewsScreeningInterviewRemind,
    getInterviewsScreeningInterviewSpeechToken,
    getInterviewsScreeningWebrtcBootstrap,
    getInterviewsScreeningWebrtcNetworkProbe,
    getInterviewsScreeningWebrtcOutput,
    getJd,
    getJdAgentConversation,
    getJdAgentSpeechToken,
    getJdExtractText,
    getJdId,
    getJdIdLinkedJobs,
    getJobApplications,
    getJobApplicationsId,
    getJobApplicationsIdApplicantHistory,
    getJobApplicationsProcessing,
    getJobApplicationsStatus,
    getJobApprovers,
    getJobApproversApprove,
    getJobs,
    getJobsId,
    getJobsIdActivity,
    getJobsIdCandidateMatching,
    getJobsIdLocations,
    getJobsIdShortlistRuleAffectedCandidates,
    getJobsIdSourcedCandidates,
    getJobsIdSourcedCandidatesSourcedCandidateIdNotes,
    getJobsSearch,
    getMetrics,
    getMetricsStatusChange,
    getNotes,
    getNotesByEmail,
    getNotifications,
    getOffers,
    getOffersApprove,
    getOffersUploadDocumentsId,
    getOgApply,
    getOgCompany,
    getOgDefault,
    getOnboardingPlans,
    getOnboardingStatus,
    getOnboardingVerifyStatus,
    getRecordingsRecordingId,
    getRekognitionGetResultsSessionId,
    getReportsConfigCompanyId,
    getReportsTaTracker,
    getSettingsCommunicationTemplates,
    getSettingsCommunicationTemplatesId,
    getSourcingJobs,
    getSseTest,
    getSseV2,
    getStorageAccess,
    getStorageUpload,
    getTemporalCheatDetectionConfig,
    getTemporalCompaniesIdAgentMemoryFlags,
    getTemporalHiQuestions,
    getTemporalIntegrations,
    getTemporalInterviewQualityCheck,
    getTemporalInterviewQualityContext,
    getTemporalJobApplicationsId,
    getTemporalJobApplicationsStatus,
    getTemporalJobsId,
    getTemporalScreeningCall,
    getTemporalScreeningInterview,
    getUserData,
    getWebhooksAzureEmail,
    getWebhooksGraph,
    getWebhooksGraphTranscript,
    getWebhooksPlivoVoice,
    getWebhooksPlivoWhatsapp,
    getWebhooksTwilioWhatsapp,
    getWellKnownScreeningJwks,
    getWhatsapp,
    getWhatsappCompanySlug,
    headInterviewsScreeningWebrtcNetworkProbe,
    type Options,
    patchAdminBillingPlansId,
    patchAdminCompaniesIdArchive,
    patchAdminCompaniesIdBilling,
    patchAdminCompaniesIdFeatureFlags,
    patchAdminCompaniesIdIntegrations,
    patchAdminCompaniesIdOrgConfig,
    patchAdminInterviewQualityIssuesId,
    patchCalendarGenerateTranscript,
    patchCompanyCompanySlugApprovalFlow,
    patchCompanyCompanySlugApprovalFlowRuleId,
    patchCompanyCompanySlugCandidateStatusesConfigStatusId,
    patchCompanyCompanySlugDepartments,
    patchCompanyCompanySlugIntegrations,
    patchCompanyCompanySlugScreeningWebrtcConfig,
    patchCompanyCompanySlugUsersUserId,
    patchCronCandidates,
    patchCustomAnalyticsDashboard,
    patchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummary,
    patchJdId,
    patchJobApplications,
    patchJobApplicationsStatus,
    patchJobOpeningsId,
    patchJobsIdSourcedCandidatesSourcedCandidateId,
    patchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteId,
    patchJobsIdStatus,
    patchOnboardingOrg,
    postAdminBillingCreditCosts,
    postAdminBillingCreditCostsImport,
    postAdminBillingPlans,
    postAdminBillingPlansIdSync,
    postAdminBillingPlansImport,
    postAdminCompanies,
    postAdminCompaniesIdCredits,
    postAdminCompaniesIdIntegrations,
    postAdminCompaniesIdIntegrationsIntegrationIdReencrypt,
    postAdminCompaniesIdLinkIntalentUser,
    postAdminInterviewQualityResolve,
    postAdminInterviewQualityRuns,
    postAdminOrganizations,
    postAdminOrganizationsUploadLogo,
    postAnalyticsAgent,
    postAnalyticsAgentStream,
    postAssessmentParams,
    postAssessmentParamsIdCopy,
    postAssessmentTemplates,
    postAuthSetCompany,
    postBillingChangePlan,
    postBillingCompleteCheckout,
    postBillingCreditPacks,
    postBillingPortal,
    postCalendar,
    postCalendarAvailability,
    postCalendarGenerateTranscript,
    postCalendarPanelistSlots,
    postCalendarPanelistSlotsComments,
    postCalendarPanelistSlotsGenerate,
    postCalendarSchedulingSlots,
    postCandidates,
    postCandidatesBulkDelete,
    postCandidatesParseQuery,
    postCompanyCompanySlugApprovalFlow,
    postCompanyCompanySlugCandidateStatusesConfig,
    postCompanyCompanySlugDepartments,
    postCompanyCompanySlugIntegrationsDisconnect,
    postCompanyCompanySlugIntegrationsLinkedinVerify,
    postCompanyCompanySlugIntegrationsTest,
    postCompanyCompanySlugLogo,
    postCompanyCompanySlugUsers,
    postCompanyCompanySlugUsersDisable,
    postCompanyCompanySlugUsersEnable,
    postCompanyCompanySlugUsersUserIdResetPassword,
    postCompanyConfig,
    postCompanyGrade,
    postCompanySlugCandidateSharingCreate,
    postCompanySlugJobsJobPostingIdTalentPoolInvites,
    postCompanySlugPublicCareerJobsIdApplications,
    postCompanySlugPublicCareerTalentPoolApplications,
    postCompanyTitleGrade,
    postCronAiInterviewReminders,
    postCronAnalyticsRefresh,
    postCronBillingCapacityRebill,
    postCronFeedbackReminders,
    postCronJobApplicationProcessing,
    postCronRenewCalendarSubscriptions,
    postCronScreeningWebrtcLifecycleSweeper,
    postCustomAnalytics,
    postCustomAnalyticsAssignDashboard,
    postCustomAnalyticsDashboard,
    postCustomAnalyticsOrder,
    postCustomAnalyticsPaginate,
    postCustomAnalyticsPreview,
    postCustomAnalyticsRemoveDashboard,
    postEmbeddings,
    postGenerateQuestions,
    postHiringManagers,
    postInsightsBenettonApplicantsReport,
    postInsightsCandidatesByRolesReport,
    postInsightsCandidatesByStatusReport,
    postInsightsCustomCharts,
    postInsightsMonthlyDashboard,
    postInsightsOfferJoinedReport,
    postInsightsOpenPositionsReport,
    postInsightsPositionsClosedReport,
    postInsightsPositionsCreatedReport,
    postInsightsPredefinedGraphs,
    postInsightsPredefinedGraphsSave,
    postInternalAnalyticsQuery,
    postInternalStt,
    postInterviews,
    postInterviewsFeedbackGenerate,
    postInterviewsHumanInterviewQuestions,
    postInterviewsHumanInterviewQuestionsTrigger,
    postInterviewsIdInterviewRound,
    postInterviewsIdInterviewRoundInterviewRoundIdGenerateSummary,
    postInterviewsIdInterviewRoundInterviewRoundIdRatings,
    postInterviewsScreeningCall,
    postInterviewsScreeningCallBulk,
    postInterviewsScreeningCallEndInterview,
    postInterviewsScreeningCallIdRecordingFetch,
    postInterviewsScreeningCallLifecycle,
    postInterviewsScreeningInterview,
    postInterviewsScreeningInterviewClientToken,
    postInterviewsScreeningInterviewDailyRecording,
    postInterviewsScreeningInterviewEndInterview,
    postInterviewsScreeningInterviewEvents,
    postInterviewsScreeningInterviewFastrtcRecording,
    postInterviewsScreeningInterviewFetchDailyRecording,
    postInterviewsScreeningInterviewFixLivenessStatus,
    postInterviewsScreeningInterviewProctoring,
    postInterviewsScreeningInterviewStart,
    postInterviewsScreeningInterviewTransitionToStarted,
    postInterviewsScreeningInterviewTtsEnsure,
    postInterviewsScreeningWebrtcAbandon,
    postInterviewsScreeningWebrtcLifecycle,
    postInterviewsScreeningWebrtcOffer,
    postInterviewsScreeningWebrtcRecordingChunk,
    postInterviewsScreeningWebrtcRecordingFinalize,
    postInterviewsScreeningWebrtcRecordingInit,
    postInterviewsScreeningWebrtcRecordingPartUrl,
    postInterviewsScreeningWebrtcSession,
    postInterviewsScreeningWebrtcSessionLogAppend,
    postInterviewsScreeningWebrtcSessionLogFinalize,
    postInterviewsScreeningWebrtcSessionSessionIdConnect,
    postInterviewsScreeningWebrtcToken,
    postJd,
    postJdAgentBackend,
    postJdAgentBackendStream,
    postJdAgentConversationSync,
    postJdExtractText,
    postJobApplications,
    postJobApplicationsBulkDelete,
    postJobApplicationsBulkReprocess,
    postJobApplicationsId,
    postJobApplicationsIdReprocess,
    postJobApprovers,
    postJobApproversBypassId,
    postJobApproversReminderId,
    postJobs,
    postJobsBulkDelete,
    postJobsIdSourcedCandidatesSourcedCandidateIdInviteDrafts,
    postJobsIdSourcedCandidatesSourcedCandidateIdInviteEmails,
    postJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreview,
    postJobsIdSourcedCandidatesSourcedCandidateIdMove,
    postJobsIdSourcedCandidatesSourcedCandidateIdNotes,
    postMailboxMonitoring,
    postMailboxMonitoringProcess,
    postMarleeCommand,
    postMarleeSession,
    postNaukriJob,
    postNotes,
    postOffers,
    postOffersRemind,
    postOffersRequestDocuments,
    postOffersSend,
    postOffersSendForApproval,
    postOffersUploadDocumentsId,
    postOnboardingCompleteCheckout,
    postOnboardingCompleteSignup,
    postOnboardingSelectPlan,
    postOnboardingSignup,
    postOnboardingUploadLogo,
    postOnboardingVerifyCode,
    postOnboardingVerifyStatus,
    postPermissions,
    postReachOut,
    postReachOutSlotBooking,
    postRekognitionCreateSession,
    postReportsConfigCompanyId,
    postReportsExecute,
    postScreeningReportPdf,
    postSendEmail,
    postSettingsCommunicationTemplates,
    postSettingsCommunicationTemplatesActivateDefault,
    postSettingsCommunicationTemplatesPreview,
    postSourcingExtract,
    postSourcingSourcedCandidates,
    postTemporalCandidate,
    postTemporalCommunicationStatus,
    postTemporalInterviewQualityReport,
    postTemporalInterviewQualityRunsRunIdStatus,
    postTemporalScreeningCallObjectiveEvaluations,
    postTemporalWorkshorts,
    postWebhooksAzureEmail,
    postWebhooksDaily,
    postWebhooksGraph,
    postWebhooksGraphTranscript,
    postWebhooksPlivoRecording,
    postWebhooksPlivoVoice,
    postWebhooksPlivoWhatsapp,
    postWebhooksResendEmail,
    postWebhooksStripe,
    postWebhooksTwilioRecording,
    postWebhooksTwilioVoice,
    postWebhooksTwilioWhatsapp,
    postWhatsapp,
    postWhatsappCompanySlug,
    putAdminBillingCreditCostsId,
    putAdminCompaniesId,
    putAdminCompaniesIdAccessControl,
    putAssessmentParamsId,
    putAssessmentTemplatesId,
    putAuthProfile,
    putCalendar,
    putCandidateSharingSharingSlugFeedback,
    putCandidatesId,
    putCompanyCompanySlugAccessControlConfig,
    putCompanyCompanySlugCandidateStatusesConfig,
    putCompanyCompanySlugJdTemplate,
    putCompanyCompanySlugJobPostingConfig,
    putCompanyConfig,
    putGenerateQuestionsId,
    putHiringManagersId,
    putInterviewsFeedback,
    putInterviewsId,
    putInterviewsIdInterviewRound,
    putInterviewsIdInterviewRoundInterviewRoundId,
    putInterviewsScreeningCall,
    putInterviewsScreeningInterview,
    putInterviewsScreeningWebrtcNetworkProbe,
    putJobApplicationsApprove,
    putJobApplicationsId,
    putJobApproversApprove,
    putJobsId,
    putNotesId,
    putNotifications,
    putOffers,
    putOffersAccept,
    putOffersApprove,
    putOffersDocuments,
    putOffersUploadDocumentsId,
    putSettingsCommunicationTemplatesId,
    putTemporalJobApplicationsId,
    putTemporalScreeningCall,
} from './sdk.gen'
export {
    type AddableSingleRoleSchema,
    type AddApprovalRoutingSchema,
    type AddCompanyUser201Data,
    type AddCompanyUser201Response,
    type AddGradeApiResponseSchema,
    type AddGradeBodySchema,
    type AddTitleGradeApiResponseSchema,
    type AddTitleGradeBodySchema,
    type AddUserBodySchema,
    type AddUserSchema,
    type AdminBillingPlanIdParamsSchema,
    type AdminCompanyBillingApiResponseSchema,
    type AdminCompanyBillingBodySchema,
    type AdminCompanyBillingIdParamsSchema,
    type AdminCompanyBillingSubscriptionSchema,
    type AdminCompanyCreditLedgerApiResponseSchema,
    type AdminCompanyCreditLedgerEntrySchema,
    type AdminCompanyCreditLedgerPayloadSchema,
    type AdminCompanyCreditLedgerQuerySchema,
    type AdminCompanyCreditLedgerSummarySchema,
    type AdminCompanyCreditsApiResponseSchema,
    type AdminCompanyCreditsBalanceApiResponseSchema,
    type AdminCompanyCreditsBalanceSchema,
    type AdminCompanyCreditsBodySchema,
    type AdminCompanyCreditsIdParamsSchema,
    type AdminCompanyCreditsPayloadSchema,
    type AdminCompanyIdParams,
    type AdminCreditCostEntrySchema,
    type AdminCreditCostsApiResponseSchema,
    type AdminCreditCostSetApiResponseSchema,
    type AdminCreditCostSetCreateBodySchema,
    type AdminCreditCostSetIdParamsSchema,
    type AdminCreditCostSetSchema,
    type AdminCreditCostSetsListApiResponseSchema,
    type AdminCreditCostSetUpdateBodySchema,
    type AdminCreditCostsPayloadSchema,
    type AdminCreditCostsUpdateBodySchema,
    type AdminIntegrationReencryptApiResponseSchema,
    type AdminIntegrationReencryptParamsSchema,
    type AdminInterviewQualityIssueIdParamsSchema,
    type AdminInterviewQualityIssueTriageApiResponseSchema,
    type AdminInterviewQualityIssueTriageBodySchema,
    type AdminInterviewQualityMatchSchema,
    type AdminInterviewQualityReportApiResponseSchema,
    type AdminInterviewQualityReportDetailSchema,
    type AdminInterviewQualityReportIdParamsSchema,
    type AdminInterviewQualityReportIssueSchema,
    type AdminInterviewQualityReportRowSchema,
    type AdminInterviewQualityReportsApiResponseSchema,
    type AdminInterviewQualityReportsQueryParamsSchema,
    type AdminInterviewQualityResolveApiResponseSchema,
    type AdminInterviewQualityResolveBodySchema,
    type AdminInterviewQualityRunApiResponseSchema,
    type AdminInterviewQualityRunCreateBodySchema,
    type AdminInterviewQualityRunsApiResponseSchema,
    type AdminInterviewQualityRunSchema,
    type AdminInterviewQualityRunsQueryParamsSchema,
    type AdminInterviewQualityTriagedIssueSchema,
    type AdminSignupDraftItemSchema,
    type AdminSignupDraftPlanSchema,
    type AdminSignupDraftsApiResponseSchema,
    type AffectedCandidatesParamsSchema,
    type AffectedCandidatesQueryParamsSchema,
    type AffectedCandidatesResponseSchema,
    type ApiResponse,
    type ApplicantHistoryApplicationSchema,
    type ApplicantHistoryInterviewRoundSchema,
    type ApplicationQuestionsSchema,
    type ApproverSchema,
    type ArchiveCompanyBodySchema,
    AssessmentLevelSchema,
    type AssessmentParamByIdQuerySchema,
    type AssessmentParamChannelFieldsSchema,
    type AssessmentParamDeleteResponseSchema,
    type AssessmentParamDetailResponseSchema,
    type AssessmentParamIdParamsSchema,
    type AssessmentParamQuestionSchema,
    type AssessmentParamResponseSchema,
    type AssessmentParamSchema,
    type AssessmentParamsListDataSchema,
    type AssessmentParamsListQuerySchema,
    type AssessmentParamsListResponseSchema,
    type AssessmentTemplateByIdQuerySchema,
    type AssessmentTemplateDeleteResponseSchema,
    type AssessmentTemplateIdParamsSchema,
    type AssessmentTemplateParameterResponseSchema,
    type AssessmentTemplateParameterSchema,
    type AssessmentTemplateResponseSchema,
    type AssessmentTemplateSchema,
    type AssessmentTemplatesListDataSchema,
    type AssessmentTemplatesListQuerySchema,
    type AssessmentTemplatesListResponseSchema,
    type AuthProfileApiResponseSchema,
    type AuthProfileQueryParamsSchema,
    type AuthProfileUserPayloadSchema,
    type BackendChatbotConfig,
    type BackendChatbotDependentFieldConfig,
    type BackendChatbotFieldConfig,
    type BackendJobPostingExtrasSchema,
    type BillingCapacityBlockApiResponseSchema,
    type BillingCapacityBlockBodySchema,
    type BillingCapacityBlockPayloadSchema,
    type BillingCapacityGrantSchema,
    type BillingChangePlanApiResponseSchema,
    type BillingChangePlanBodySchema,
    type BillingChangePlanPayloadSchema,
    type BillingCompanySlugQuerySchema,
    type BillingCompleteCheckoutApiResponseSchema,
    type BillingCompleteCheckoutBodySchema,
    type BillingCreditCostEntryPortableSchema,
    type BillingCreditCostSetPortableSchema,
    type BillingCreditCostsExportApiResponseSchema,
    type BillingCreditCostsExportSchema,
    type BillingCreditCostsImportApiResponseSchema,
    type BillingCreditCostsImportSummarySchema,
    type BillingCreditPackBodySchema,
    type BillingPlanApiResponseSchema,
    type BillingPlanApiSchema,
    type BillingPlanCreateSchema,
    type BillingPlanFeatureFlagsSchema,
    type BillingPlanLimitsSchema,
    type BillingPlanPortableSchema,
    type BillingPlansExportApiResponseSchema,
    type BillingPlansExportSchema,
    type BillingPlansImportApiResponseSchema,
    type BillingPlansImportSummarySchema,
    type BillingPlansListApiResponseSchema,
    type BillingPlanUpdateSchema,
    type BillingPortalApiResponseSchema,
    type BillingPortalBodySchema,
    type BillingPortalPayloadSchema,
    type BillingPublicPlansApiResponseSchema,
    type BillingPublicPlanSchema,
    type BillingSubscriptionApiResponseSchema,
    type BillingSubscriptionPlanSummarySchema,
    type BillingSubscriptionSummarySchema,
    type BillingUsageApiResponseSchema,
    type BillingUsageCountsSchema,
    type BillingUsagePayloadSchema,
    type BulkDeleteCandidatesSchema,
    type BulkDeleteJobApplicationsSchema,
    type BulkDeleteJobPostingsSchema,
    type BulkReprocessJobApplicationsSchema,
    type BulkUpdateJobApplicationsSchema,
    type CallQualityMetricsSchema,
    type CallQualitySchema,
    type CandidatesListApiResponseSchema,
    type CandidatesListPayloadSchema,
    type CandidatesListQueryParamsSchema,
    type ClientOptions,
    type CompanyConfigSchema,
    type CompanyDepartmentListSchema,
    type CompanyDepartmentsApiResponseSchema,
    type CompanyDepartmentsQueryParamsSchema,
    type CompanyDomainSchema,
    type CompanyRequestParamsSchema,
    type CompanySchema,
    type CompanySlugParam,
    type CompanySlugParams,
    type CompanySlugParamSchema,
    type CompanySlugParamsSchema,
    type CompanySlugSchema,
    type CompanyUserDepartmentOpenApi,
    type CompanyUserIdParams,
    type CompanyUserListItemOpenApi,
    type CompanyUsersResponse,
    ConfigModeSchema,
    type CopyAssessmentParamBodySchema,
    type CostsRecordSchema,
    type CreateAssessmentParamBodySchema,
    type CreateAssessmentTemplateBodySchema,
    type CreateCandidateSchema,
    type CreateDepartmentBodySchema,
    type CreateInterviewRoundSchema,
    type CreateInterviewSchema,
    type CreateJobApplicationSchema,
    type CreateJobApplicationSchemaBulk,
    type CreateJobDescriptionBodySchema,
    type CreateJobDescriptionSchema,
    type CreateJobOfferSchema,
    type CreateJobPostingApiResponseSchema,
    type CreateJobPostingBodySchema,
    type CreateJobPostingErrorSchema,
    type CreateJobSchema,
    type CreateOrganizationFormSchema,
    type CreateOrganizationSchema,
    type CreateReferralSchema,
    type CreateRoutingRuleSchema,
    type CreateStatusSchema,
    type CreateSuccessProfileSchema,
    CreditGrantModeSchema,
    type CustomShape,
    type DataSourceSchema,
    type DeleteAdminBillingCreditCostsIdData,
    type DeleteAdminBillingCreditCostsIdError,
    type DeleteAdminBillingCreditCostsIdErrors,
    type DeleteAdminBillingCreditCostsIdResponse,
    type DeleteAdminBillingCreditCostsIdResponses,
    type DeleteAdminBillingPlansIdData,
    type DeleteAdminBillingPlansIdError,
    type DeleteAdminBillingPlansIdErrors,
    type DeleteAdminBillingPlansIdResponse,
    type DeleteAdminBillingPlansIdResponses,
    type DeleteAssessmentParamsIdData,
    type DeleteAssessmentParamsIdError,
    type DeleteAssessmentParamsIdErrors,
    type DeleteAssessmentParamsIdResponse,
    type DeleteAssessmentParamsIdResponses,
    type DeleteAssessmentTemplatesIdData,
    type DeleteAssessmentTemplatesIdError,
    type DeleteAssessmentTemplatesIdErrors,
    type DeleteAssessmentTemplatesIdResponse,
    type DeleteAssessmentTemplatesIdResponses,
    type DeleteCandidatesIdData,
    type DeleteCandidatesIdError,
    type DeleteCandidatesIdErrors,
    type DeleteCompanyCompanySlugApprovalFlowRuleIdData,
    type DeleteCompanyCompanySlugApprovalFlowRuleIdError,
    type DeleteCompanyCompanySlugApprovalFlowRuleIdErrors,
    type DeleteCompanyCompanySlugApprovalFlowRuleIdResponse,
    type DeleteCompanyCompanySlugApprovalFlowRuleIdResponses,
    type DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdData,
    type DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdError,
    type DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdErrors,
    type DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdResponse,
    type DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdResponses,
    type DeleteCompanyCompanySlugDepartmentsData,
    type DeleteCompanyCompanySlugDepartmentsError,
    type DeleteCompanyCompanySlugDepartmentsErrors,
    type DeleteCompanyCompanySlugDepartmentsResponse,
    type DeleteCompanyCompanySlugDepartmentsResponses,
    type DeleteCustomAnalyticsDashboardData,
    type DeleteCustomAnalyticsDashboardError,
    type DeleteCustomAnalyticsDashboardErrors,
    type DeleteCustomAnalyticsIdData,
    type DeleteCustomAnalyticsIdError,
    type DeleteCustomAnalyticsIdErrors,
    type DeleteCustomAnalyticsIdResponse,
    type DeleteCustomAnalyticsIdResponses,
    type DeleteDepartmentQueryParamsSchema,
    type DeleteHiringManagersIdData,
    type DeleteHiringManagersIdError,
    type DeleteHiringManagersIdErrors,
    type DeleteInterviewsIdData,
    type DeleteInterviewsIdError,
    type DeleteInterviewsIdErrors,
    type DeleteInterviewsIdInterviewRoundInterviewRoundIdData,
    type DeleteInterviewsIdInterviewRoundInterviewRoundIdError,
    type DeleteInterviewsIdInterviewRoundInterviewRoundIdErrors,
    type DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistData,
    type DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistError,
    type DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistErrors,
    type DeleteInterviewsIdInterviewRoundInterviewRoundIdResponse,
    type DeleteInterviewsIdInterviewRoundInterviewRoundIdResponses,
    type DeleteInterviewsIdResponse,
    type DeleteInterviewsIdResponses,
    type DeleteInterviewsScreeningCallData,
    type DeleteInterviewsScreeningCallError,
    type DeleteInterviewsScreeningCallErrors,
    type DeleteInterviewsScreeningInterviewClientTokenIdData,
    type DeleteInterviewsScreeningInterviewClientTokenIdError,
    type DeleteInterviewsScreeningInterviewClientTokenIdErrors,
    type DeleteInterviewsScreeningInterviewClientTokenIdResponse,
    type DeleteInterviewsScreeningInterviewClientTokenIdResponses,
    type DeleteInterviewsScreeningInterviewIdentityCheckIdData,
    type DeleteInterviewsScreeningInterviewIdentityCheckIdError,
    type DeleteInterviewsScreeningInterviewIdentityCheckIdErrors,
    type DeleteInterviewsScreeningInterviewSpeechTokenIdData,
    type DeleteInterviewsScreeningInterviewSpeechTokenIdError,
    type DeleteInterviewsScreeningInterviewSpeechTokenIdErrors,
    type DeleteInterviewsScreeningInterviewSpeechTokenIdResponse,
    type DeleteInterviewsScreeningInterviewSpeechTokenIdResponses,
    type DeleteJdIdData,
    type DeleteJdIdError,
    type DeleteJdIdErrors,
    type DeleteJdIdResponse,
    type DeleteJdIdResponses,
    type DeleteJobApplicationsIdData,
    type DeleteJobApplicationsIdError,
    type DeleteJobApplicationsIdErrors,
    type DeleteJobApplicationsIdResponse,
    type DeleteJobApplicationsIdResponses,
    type DeleteJobsIdData,
    type DeleteJobsIdError,
    type DeleteJobsIdErrors,
    type DeleteJobsIdResponse,
    type DeleteJobsIdResponses,
    type DeleteJobsIdSourcedCandidatesSourcedCandidateIdData,
    type DeleteJobsIdSourcedCandidatesSourcedCandidateIdError,
    type DeleteJobsIdSourcedCandidatesSourcedCandidateIdErrors,
    type DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdData,
    type DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdError,
    type DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdErrors,
    type DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdResponse,
    type DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdResponses,
    type DeleteJobsIdSourcedCandidatesSourcedCandidateIdResponse,
    type DeleteJobsIdSourcedCandidatesSourcedCandidateIdResponses,
    type DeleteMarleeSessionSessionIdData,
    type DeleteMarleeSessionSessionIdError,
    type DeleteMarleeSessionSessionIdErrors,
    type DeleteMarleeSessionSessionIdResponse,
    type DeleteMarleeSessionSessionIdResponses,
    type DeleteNotesIdData,
    type DeleteNotesIdError,
    type DeleteNotesIdErrors,
    type DeleteNotificationsIdData,
    type DeleteNotificationsIdError,
    type DeleteNotificationsIdErrors,
    type DeleteNotificationsIdResponse,
    type DeleteNotificationsIdResponses,
    type DeleteSettingsCommunicationTemplatesIdData,
    type DeleteSettingsCommunicationTemplatesIdError,
    type DeleteSettingsCommunicationTemplatesIdErrors,
    type DeleteSettingsCommunicationTemplatesIdResponse,
    type DeleteSettingsCommunicationTemplatesIdResponses,
    type DeleteStatusSchema,
    type DepartmentApiResponseSchema,
    type DepartmentApproverSchema,
    type DepartmentDeleteApiResponseSchema,
    type DepartmentPayloadSchema,
    type DepartmentRowSchema,
    type DepartmentSchema,
    type DisableBodySchema,
    type EditCompanyUser200Response,
    type EditUserBodySchema,
    type EmailSchema,
    type EmailValidation,
    type EnableBodySchema,
    type ExtractTextApiResponseSchema,
    type ExtractTextMultipartSchema,
    type ExtractTextQuerySchema,
    type FeatureFlagsBodySchema,
    type FormSchema,
    type GetAdminBillingCreditCostsData,
    type GetAdminBillingCreditCostsError,
    type GetAdminBillingCreditCostsErrors,
    type GetAdminBillingCreditCostsExportData,
    type GetAdminBillingCreditCostsExportError,
    type GetAdminBillingCreditCostsExportErrors,
    type GetAdminBillingCreditCostsExportResponse,
    type GetAdminBillingCreditCostsExportResponses,
    type GetAdminBillingCreditCostsIdData,
    type GetAdminBillingCreditCostsIdError,
    type GetAdminBillingCreditCostsIdErrors,
    type GetAdminBillingCreditCostsIdResponse,
    type GetAdminBillingCreditCostsIdResponses,
    type GetAdminBillingCreditCostsResponse,
    type GetAdminBillingCreditCostsResponses,
    type GetAdminBillingPlansData,
    type GetAdminBillingPlansError,
    type GetAdminBillingPlansErrors,
    type GetAdminBillingPlansExportData,
    type GetAdminBillingPlansExportError,
    type GetAdminBillingPlansExportErrors,
    type GetAdminBillingPlansExportResponse,
    type GetAdminBillingPlansExportResponses,
    type GetAdminBillingPlansIdData,
    type GetAdminBillingPlansIdError,
    type GetAdminBillingPlansIdErrors,
    type GetAdminBillingPlansIdResponse,
    type GetAdminBillingPlansIdResponses,
    type GetAdminBillingPlansResponse,
    type GetAdminBillingPlansResponses,
    type GetAdminBillingSignupDraftsData,
    type GetAdminBillingSignupDraftsError,
    type GetAdminBillingSignupDraftsErrors,
    type GetAdminBillingSignupDraftsResponse,
    type GetAdminBillingSignupDraftsResponses,
    type GetAdminCompaniesData,
    type GetAdminCompaniesError,
    type GetAdminCompaniesErrors,
    type GetAdminCompaniesIdAccessControlData,
    type GetAdminCompaniesIdAccessControlError,
    type GetAdminCompaniesIdAccessControlErrors,
    type GetAdminCompaniesIdAccessControlResponse,
    type GetAdminCompaniesIdAccessControlResponses,
    type GetAdminCompaniesIdCreditsData,
    type GetAdminCompaniesIdCreditsError,
    type GetAdminCompaniesIdCreditsErrors,
    type GetAdminCompaniesIdCreditsLedgerData,
    type GetAdminCompaniesIdCreditsLedgerError,
    type GetAdminCompaniesIdCreditsLedgerErrors,
    type GetAdminCompaniesIdCreditsLedgerResponse,
    type GetAdminCompaniesIdCreditsLedgerResponses,
    type GetAdminCompaniesIdCreditsResponse,
    type GetAdminCompaniesIdCreditsResponses,
    type GetAdminCompaniesIdData,
    type GetAdminCompaniesIdError,
    type GetAdminCompaniesIdErrors,
    type GetAdminCompaniesIdIntegrationsData,
    type GetAdminCompaniesIdIntegrationsError,
    type GetAdminCompaniesIdIntegrationsErrors,
    type GetAdminCompaniesIdIntegrationsResponse,
    type GetAdminCompaniesIdIntegrationsResponses,
    type GetAdminCompaniesIdResponse,
    type GetAdminCompaniesIdResponses,
    type GetAdminCompaniesResponse,
    type GetAdminCompaniesResponses,
    type GetAdminIntalentUsersData,
    type GetAdminIntalentUsersError,
    type GetAdminIntalentUsersErrors,
    type GetAdminIntalentUsersResponse,
    type GetAdminIntalentUsersResponses,
    type GetAdminInterviewQualityReportsData,
    type GetAdminInterviewQualityReportsError,
    type GetAdminInterviewQualityReportsErrors,
    type GetAdminInterviewQualityReportsIdData,
    type GetAdminInterviewQualityReportsIdError,
    type GetAdminInterviewQualityReportsIdErrors,
    type GetAdminInterviewQualityReportsIdResponse,
    type GetAdminInterviewQualityReportsIdResponses,
    type GetAdminInterviewQualityReportsResponse,
    type GetAdminInterviewQualityReportsResponses,
    type GetAdminInterviewQualityRunsData,
    type GetAdminInterviewQualityRunsError,
    type GetAdminInterviewQualityRunsErrors,
    type GetAdminInterviewQualityRunsResponse,
    type GetAdminInterviewQualityRunsResponses,
    type GetApplicationsSearchData,
    type GetApplicationsSearchError,
    type GetApplicationsSearchErrors,
    type GetApplicationsSearchResponse,
    type GetApplicationsSearchResponses,
    type GetAssessmentParamsData,
    type GetAssessmentParamsError,
    type GetAssessmentParamsErrors,
    type GetAssessmentParamsIdData,
    type GetAssessmentParamsIdError,
    type GetAssessmentParamsIdErrors,
    type GetAssessmentParamsIdResponse,
    type GetAssessmentParamsIdResponses,
    type GetAssessmentParamsResponse,
    type GetAssessmentParamsResponses,
    type GetAssessmentTemplatesData,
    type GetAssessmentTemplatesError,
    type GetAssessmentTemplatesErrors,
    type GetAssessmentTemplatesIdData,
    type GetAssessmentTemplatesIdError,
    type GetAssessmentTemplatesIdErrors,
    type GetAssessmentTemplatesIdResponse,
    type GetAssessmentTemplatesIdResponses,
    type GetAssessmentTemplatesResponse,
    type GetAssessmentTemplatesResponses,
    type GetAuthLogoutCallbackData,
    type GetAuthLogoutCallbackError,
    type GetAuthLogoutCallbackErrors,
    type GetAuthMyCompaniesData,
    type GetAuthMyCompaniesError,
    type GetAuthMyCompaniesErrors,
    type GetAuthMyCompaniesResponse,
    type GetAuthMyCompaniesResponses,
    type GetAuthProfileData,
    type GetAuthProfileError,
    type GetAuthProfileErrors,
    type GetAuthProfileResponse,
    type GetAuthProfileResponses,
    type GetAuthSwitchCompanyData,
    type GetAuthSwitchCompanyError,
    type GetAuthSwitchCompanyErrors,
    type GetBillingPlansData,
    type GetBillingPlansError,
    type GetBillingPlansErrors,
    type GetBillingPlansResponse,
    type GetBillingPlansResponses,
    type GetBillingSubscriptionData,
    type GetBillingSubscriptionError,
    type GetBillingSubscriptionErrors,
    type GetBillingSubscriptionResponse,
    type GetBillingSubscriptionResponses,
    type GetBillingUsageData,
    type GetBillingUsageError,
    type GetBillingUsageErrors,
    type GetBillingUsageResponse,
    type GetBillingUsageResponses,
    type GetCandidatesData,
    type GetCandidatesError,
    type GetCandidatesErrors,
    type GetCandidateSharingSharingSlugData,
    type GetCandidateSharingSharingSlugError,
    type GetCandidateSharingSharingSlugErrors,
    type GetCandidatesIdData,
    type GetCandidatesIdError,
    type GetCandidatesIdErrors,
    type GetCandidatesResponse,
    type GetCandidatesResponses,
    type GetChatbotConfigData,
    type GetChatbotConfigError,
    type GetChatbotConfigErrors,
    type GetChatbotConfigResponse,
    type GetChatbotConfigResponses,
    type GetCommunicationStatusEmailClientIdData,
    type GetCommunicationStatusEmailClientIdError,
    type GetCommunicationStatusEmailClientIdErrors,
    type GetCompanyCompanySlugAccessControlConfigData,
    type GetCompanyCompanySlugAccessControlConfigError,
    type GetCompanyCompanySlugAccessControlConfigErrors,
    type GetCompanyCompanySlugAccessControlConfigResponse,
    type GetCompanyCompanySlugAccessControlConfigResponses,
    type GetCompanyCompanySlugApprovalFlowData,
    type GetCompanyCompanySlugApprovalFlowError,
    type GetCompanyCompanySlugApprovalFlowErrors,
    type GetCompanyCompanySlugApprovalFlowResponse,
    type GetCompanyCompanySlugApprovalFlowResponses,
    type GetCompanyCompanySlugCandidateStatusesConfigData,
    type GetCompanyCompanySlugCandidateStatusesConfigError,
    type GetCompanyCompanySlugCandidateStatusesConfigErrors,
    type GetCompanyCompanySlugCandidateStatusesConfigResponse,
    type GetCompanyCompanySlugCandidateStatusesConfigResponses,
    type GetCompanyCompanySlugDepartmentsData,
    type GetCompanyCompanySlugDepartmentsError,
    type GetCompanyCompanySlugDepartmentsErrors,
    type GetCompanyCompanySlugDepartmentsResponse,
    type GetCompanyCompanySlugDepartmentsResponses,
    type GetCompanyCompanySlugIntegrationsData,
    type GetCompanyCompanySlugIntegrationsError,
    type GetCompanyCompanySlugIntegrationsErrors,
    type GetCompanyCompanySlugIntegrationsResponse,
    type GetCompanyCompanySlugIntegrationsResponses,
    type GetCompanyCompanySlugJdTemplateData,
    type GetCompanyCompanySlugJdTemplateError,
    type GetCompanyCompanySlugJdTemplateErrors,
    type GetCompanyCompanySlugJdTemplateResponse,
    type GetCompanyCompanySlugJdTemplateResponses,
    type GetCompanyCompanySlugJobPostingConfigData,
    type GetCompanyCompanySlugJobPostingConfigError,
    type GetCompanyCompanySlugJobPostingConfigErrors,
    type GetCompanyCompanySlugJobPostingConfigResponse,
    type GetCompanyCompanySlugJobPostingConfigResponses,
    type GetCompanyCompanySlugPanellistsData,
    type GetCompanyCompanySlugPanellistsError,
    type GetCompanyCompanySlugPanellistsErrors,
    type GetCompanyCompanySlugPanellistsResponse,
    type GetCompanyCompanySlugPanellistsResponses,
    type GetCompanyCompanySlugScreeningWebrtcConfigData,
    type GetCompanyCompanySlugScreeningWebrtcConfigError,
    type GetCompanyCompanySlugScreeningWebrtcConfigErrors,
    type GetCompanyCompanySlugScreeningWebrtcConfigResponse,
    type GetCompanyCompanySlugScreeningWebrtcConfigResponses,
    type GetCompanyCompanySlugUsersData,
    type GetCompanyCompanySlugUsersError,
    type GetCompanyCompanySlugUsersErrors,
    type GetCompanyCompanySlugUsersResponse,
    type GetCompanyCompanySlugUsersResponses,
    type GetCompanyConfigData,
    type GetCompanyConfigError,
    type GetCompanyConfigErrors,
    type GetCompanyData,
    type GetCompanyDepartmentsData,
    type GetCompanyDepartmentsError,
    type GetCompanyDepartmentsErrors,
    type GetCompanyDepartmentsResponse,
    type GetCompanyDepartmentsResponses,
    type GetCompanyEmploymentTypesData,
    type GetCompanyEmploymentTypesError,
    type GetCompanyEmploymentTypesErrors,
    type GetCompanyError,
    type GetCompanyErrors,
    type GetCompanySlugJobsJobPostingIdTalentPoolInvitesData,
    type GetCompanySlugJobsJobPostingIdTalentPoolInvitesError,
    type GetCompanySlugJobsJobPostingIdTalentPoolInvitesErrors,
    type GetCompanySlugPublicCareerConfigData,
    type GetCompanySlugPublicCareerConfigError,
    type GetCompanySlugPublicCareerConfigErrors,
    type GetCompanySlugPublicCareerConfigResponse,
    type GetCompanySlugPublicCareerConfigResponses,
    type GetCompanySlugPublicCareerDepartmentsData,
    type GetCompanySlugPublicCareerDepartmentsError,
    type GetCompanySlugPublicCareerDepartmentsErrors,
    type GetCompanySlugPublicCareerDepartmentsResponse,
    type GetCompanySlugPublicCareerDepartmentsResponses,
    type GetCompanySlugPublicCareerJobsData,
    type GetCompanySlugPublicCareerJobsError,
    type GetCompanySlugPublicCareerJobsErrors,
    type GetCompanySlugPublicCareerJobsIdData,
    type GetCompanySlugPublicCareerJobsIdError,
    type GetCompanySlugPublicCareerJobsIdErrors,
    type GetCompanySlugPublicCareerJobsIdResponse,
    type GetCompanySlugPublicCareerJobsIdResponses,
    type GetCompanySlugPublicCareerJobsIdUploadUrlData,
    type GetCompanySlugPublicCareerJobsIdUploadUrlError,
    type GetCompanySlugPublicCareerJobsIdUploadUrlErrors,
    type GetCompanySlugPublicCareerJobsIdUploadUrlResponse,
    type GetCompanySlugPublicCareerJobsIdUploadUrlResponses,
    type GetCompanySlugPublicCareerJobsResponse,
    type GetCompanySlugPublicCareerJobsResponses,
    type GetCompanySlugPublicCareerTalentPoolUploadUrlData,
    type GetCompanySlugPublicCareerTalentPoolUploadUrlError,
    type GetCompanySlugPublicCareerTalentPoolUploadUrlErrors,
    type GetCompanySlugPublicCareerTalentPoolUploadUrlResponse,
    type GetCompanySlugPublicCareerTalentPoolUploadUrlResponses,
    type GetCronAiInterviewRemindersData,
    type GetCronAiInterviewRemindersError,
    type GetCronAiInterviewRemindersErrors,
    type GetCronFeedbackRemindersData,
    type GetCronFeedbackRemindersError,
    type GetCronFeedbackRemindersErrors,
    type GetCronRenewCalendarSubscriptionsData,
    type GetCronRenewCalendarSubscriptionsError,
    type GetCronRenewCalendarSubscriptionsErrors,
    type GetCronScreeningWebrtcLifecycleSweeperData,
    type GetCronScreeningWebrtcLifecycleSweeperError,
    type GetCronScreeningWebrtcLifecycleSweeperErrors,
    type GetCustomAnalyticsData,
    type GetCustomAnalyticsError,
    type GetCustomAnalyticsErrors,
    type GetEmbeddingsData,
    type GetEmbeddingsError,
    type GetEmbeddingsErrors,
    type GetEmbeddingsResponse,
    type GetEmbeddingsResponses,
    type GetHiringManagersData,
    type GetHiringManagersError,
    type GetHiringManagersErrors,
    type GetIntegrationsGoogleAuthorizeData,
    type GetIntegrationsGoogleAuthorizeError,
    type GetIntegrationsGoogleAuthorizeErrors,
    type GetIntegrationsGoogleCallbackData,
    type GetIntegrationsGoogleCallbackError,
    type GetIntegrationsGoogleCallbackErrors,
    type GetIntegrationsMicrosoftAuthorizeData,
    type GetIntegrationsMicrosoftAuthorizeError,
    type GetIntegrationsMicrosoftAuthorizeErrors,
    type GetIntegrationsMicrosoftCallbackData,
    type GetIntegrationsMicrosoftCallbackError,
    type GetIntegrationsMicrosoftCallbackErrors,
    type GetInternalSttTokenData,
    type GetInternalSttTokenError,
    type GetInternalSttTokenErrors,
    type GetInternalSttTokenResponse,
    type GetInternalSttTokenResponses,
    type GetInterviewsData,
    type GetInterviewsError,
    type GetInterviewsErrors,
    type GetInterviewsFeedbackData,
    type GetInterviewsFeedbackError,
    type GetInterviewsFeedbackErrors,
    type GetInterviewsFeedbackTranscriptData,
    type GetInterviewsFeedbackTranscriptError,
    type GetInterviewsFeedbackTranscriptErrors,
    type GetInterviewsIdData,
    type GetInterviewsIdError,
    type GetInterviewsIdErrors,
    type GetInterviewsIdResponse,
    type GetInterviewsIdResponses,
    type GetInterviewsResponse,
    type GetInterviewsResponses,
    type GetInterviewsScreeningCallIdRecordingData,
    type GetInterviewsScreeningCallIdRecordingError,
    type GetInterviewsScreeningCallIdRecordingErrors,
    type GetInterviewsScreeningCallIdRecordingResponse,
    type GetInterviewsScreeningCallIdRecordingResponses,
    type GetInterviewsScreeningInterviewCandidateData,
    type GetInterviewsScreeningInterviewCandidateError,
    type GetInterviewsScreeningInterviewCandidateErrors,
    type GetInterviewsScreeningInterviewClientTokenData,
    type GetInterviewsScreeningInterviewClientTokenError,
    type GetInterviewsScreeningInterviewClientTokenErrors,
    type GetInterviewsScreeningInterviewClientTokenResponse,
    type GetInterviewsScreeningInterviewClientTokenResponses,
    type GetInterviewsScreeningInterviewData,
    type GetInterviewsScreeningInterviewError,
    type GetInterviewsScreeningInterviewErrors,
    type GetInterviewsScreeningInterviewIceServersData,
    type GetInterviewsScreeningInterviewIceServersError,
    type GetInterviewsScreeningInterviewIceServersErrors,
    type GetInterviewsScreeningInterviewIceServersResponse,
    type GetInterviewsScreeningInterviewIceServersResponses,
    type GetInterviewsScreeningInterviewIdentityCheckIdData,
    type GetInterviewsScreeningInterviewIdentityCheckIdError,
    type GetInterviewsScreeningInterviewIdentityCheckIdErrors,
    type GetInterviewsScreeningInterviewProctoringData,
    type GetInterviewsScreeningInterviewProctoringError,
    type GetInterviewsScreeningInterviewProctoringErrors,
    type GetInterviewsScreeningInterviewProctoringResponse,
    type GetInterviewsScreeningInterviewProctoringResponses,
    type GetInterviewsScreeningInterviewRemindData,
    type GetInterviewsScreeningInterviewRemindError,
    type GetInterviewsScreeningInterviewRemindErrors,
    type GetInterviewsScreeningInterviewRemindResponse,
    type GetInterviewsScreeningInterviewRemindResponses,
    type GetInterviewsScreeningInterviewSpeechTokenData,
    type GetInterviewsScreeningInterviewSpeechTokenError,
    type GetInterviewsScreeningInterviewSpeechTokenErrors,
    type GetInterviewsScreeningInterviewSpeechTokenResponse,
    type GetInterviewsScreeningInterviewSpeechTokenResponses,
    type GetInterviewsScreeningWebrtcBootstrapData,
    type GetInterviewsScreeningWebrtcBootstrapError,
    type GetInterviewsScreeningWebrtcBootstrapErrors,
    type GetInterviewsScreeningWebrtcBootstrapResponse,
    type GetInterviewsScreeningWebrtcBootstrapResponses,
    type GetInterviewsScreeningWebrtcNetworkProbeData,
    type GetInterviewsScreeningWebrtcNetworkProbeError,
    type GetInterviewsScreeningWebrtcNetworkProbeErrors,
    type GetInterviewsScreeningWebrtcOutputData,
    type GetInterviewsScreeningWebrtcOutputError,
    type GetInterviewsScreeningWebrtcOutputErrors,
    type GetInterviewsScreeningWebrtcOutputResponse,
    type GetInterviewsScreeningWebrtcOutputResponses,
    type GetJdAgentConversationData,
    type GetJdAgentConversationError,
    type GetJdAgentConversationErrors,
    type GetJdAgentConversationResponse,
    type GetJdAgentConversationResponses,
    type GetJdAgentSpeechTokenData,
    type GetJdAgentSpeechTokenError,
    type GetJdAgentSpeechTokenErrors,
    type GetJdAgentSpeechTokenResponse,
    type GetJdAgentSpeechTokenResponses,
    type GetJdData,
    type GetJdError,
    type GetJdErrors,
    type GetJdExtractTextData,
    type GetJdExtractTextError,
    type GetJdExtractTextErrors,
    type GetJdExtractTextResponse,
    type GetJdExtractTextResponses,
    type GetJdIdData,
    type GetJdIdError,
    type GetJdIdErrors,
    type GetJdIdLinkedJobsData,
    type GetJdIdLinkedJobsError,
    type GetJdIdLinkedJobsErrors,
    type GetJdIdLinkedJobsResponse,
    type GetJdIdLinkedJobsResponses,
    type GetJdIdResponse,
    type GetJdIdResponses,
    type GetJdResponse,
    type GetJdResponses,
    type GetJobApplicationsData,
    type GetJobApplicationsError,
    type GetJobApplicationsErrors,
    type GetJobApplicationsIdApplicantHistoryData,
    type GetJobApplicationsIdApplicantHistoryError,
    type GetJobApplicationsIdApplicantHistoryErrors,
    type GetJobApplicationsIdApplicantHistoryResponse,
    type GetJobApplicationsIdApplicantHistoryResponses,
    type GetJobApplicationsIdData,
    type GetJobApplicationsIdError,
    type GetJobApplicationsIdErrors,
    type GetJobApplicationsIdResponse,
    type GetJobApplicationsIdResponses,
    type GetJobApplicationsProcessingData,
    type GetJobApplicationsProcessingError,
    type GetJobApplicationsProcessingErrors,
    type GetJobApplicationsProcessingResponse,
    type GetJobApplicationsProcessingResponses,
    type GetJobApplicationsResponse,
    type GetJobApplicationsResponses,
    type GetJobApplicationsStatusData,
    type GetJobApplicationsStatusError,
    type GetJobApplicationsStatusErrors,
    type GetJobApplicationsStatusResponse,
    type GetJobApplicationsStatusResponses,
    type GetJobApproversApproveData,
    type GetJobApproversApproveError,
    type GetJobApproversApproveErrors,
    type GetJobApproversApproveResponse,
    type GetJobApproversApproveResponses,
    type GetJobApproversData,
    type GetJobApproversError,
    type GetJobApproversErrors,
    type GetJobApproversResponse,
    type GetJobApproversResponses,
    type GetJobsData,
    type GetJobsError,
    type GetJobsErrors,
    type GetJobsIdActivityData,
    type GetJobsIdActivityError,
    type GetJobsIdActivityErrors,
    type GetJobsIdActivityResponse,
    type GetJobsIdActivityResponses,
    type GetJobsIdCandidateMatchingData,
    type GetJobsIdCandidateMatchingError,
    type GetJobsIdCandidateMatchingErrors,
    type GetJobsIdCandidateMatchingResponse,
    type GetJobsIdCandidateMatchingResponses,
    type GetJobsIdData,
    type GetJobsIdError,
    type GetJobsIdErrors,
    type GetJobsIdLocationsData,
    type GetJobsIdLocationsError,
    type GetJobsIdLocationsErrors,
    type GetJobsIdLocationsResponse,
    type GetJobsIdLocationsResponses,
    type GetJobsIdShortlistRuleAffectedCandidatesData,
    type GetJobsIdShortlistRuleAffectedCandidatesError,
    type GetJobsIdShortlistRuleAffectedCandidatesErrors,
    type GetJobsIdShortlistRuleAffectedCandidatesResponse,
    type GetJobsIdShortlistRuleAffectedCandidatesResponses,
    type GetJobsIdSourcedCandidatesData,
    type GetJobsIdSourcedCandidatesError,
    type GetJobsIdSourcedCandidatesErrors,
    type GetJobsIdSourcedCandidatesResponse,
    type GetJobsIdSourcedCandidatesResponses,
    type GetJobsIdSourcedCandidatesSourcedCandidateIdNotesData,
    type GetJobsIdSourcedCandidatesSourcedCandidateIdNotesError,
    type GetJobsIdSourcedCandidatesSourcedCandidateIdNotesErrors,
    type GetJobsIdSourcedCandidatesSourcedCandidateIdNotesResponse,
    type GetJobsIdSourcedCandidatesSourcedCandidateIdNotesResponses,
    type GetJobsResponse,
    type GetJobsResponses,
    type GetJobsSearchData,
    type GetJobsSearchError,
    type GetJobsSearchErrors,
    type GetJobsSearchResponse,
    type GetJobsSearchResponses,
    type GetMetricsData,
    type GetMetricsError,
    type GetMetricsErrors,
    type GetMetricsResponse,
    type GetMetricsResponses,
    type GetMetricsStatusChangeData,
    type GetMetricsStatusChangeError,
    type GetMetricsStatusChangeErrors,
    type GetNotesByEmailData,
    type GetNotesByEmailError,
    type GetNotesByEmailErrors,
    type GetNotesData,
    type GetNotesError,
    type GetNotesErrors,
    type GetNotificationsData,
    type GetNotificationsError,
    type GetNotificationsErrors,
    type GetNotificationsResponse,
    type GetNotificationsResponses,
    type GetOffersApproveData,
    type GetOffersApproveError,
    type GetOffersApproveErrors,
    type GetOffersApproveResponse,
    type GetOffersApproveResponses,
    type GetOffersData,
    type GetOffersError,
    type GetOffersErrors,
    type GetOffersResponse,
    type GetOffersResponses,
    type GetOffersUploadDocumentsIdData,
    type GetOffersUploadDocumentsIdError,
    type GetOffersUploadDocumentsIdErrors,
    type GetOffersUploadDocumentsIdResponse,
    type GetOffersUploadDocumentsIdResponses,
    type GetOgApplyData,
    type GetOgApplyError,
    type GetOgApplyErrors,
    type GetOgCompanyData,
    type GetOgCompanyError,
    type GetOgCompanyErrors,
    type GetOgDefaultData,
    type GetOgDefaultError,
    type GetOgDefaultErrors,
    type GetOnboardingPlansData,
    type GetOnboardingPlansError,
    type GetOnboardingPlansErrors,
    type GetOnboardingPlansResponse,
    type GetOnboardingPlansResponses,
    type GetOnboardingStatusData,
    type GetOnboardingStatusError,
    type GetOnboardingStatusErrors,
    type GetOnboardingStatusResponse,
    type GetOnboardingStatusResponses,
    type GetOnboardingVerifyStatusData,
    type GetOnboardingVerifyStatusError,
    type GetOnboardingVerifyStatusErrors,
    type GetOnboardingVerifyStatusResponse,
    type GetOnboardingVerifyStatusResponses,
    type GetRecordingsRecordingIdData,
    type GetRecordingsRecordingIdError,
    type GetRecordingsRecordingIdErrors,
    type GetRekognitionGetResultsSessionIdData,
    type GetRekognitionGetResultsSessionIdError,
    type GetRekognitionGetResultsSessionIdErrors,
    type GetReportsConfigCompanyIdData,
    type GetReportsConfigCompanyIdError,
    type GetReportsConfigCompanyIdErrors,
    type GetReportsConfigCompanyIdResponse,
    type GetReportsConfigCompanyIdResponses,
    type GetReportsTaTrackerData,
    type GetReportsTaTrackerError,
    type GetReportsTaTrackerErrors,
    type GetSettingsCommunicationTemplatesData,
    type GetSettingsCommunicationTemplatesError,
    type GetSettingsCommunicationTemplatesErrors,
    type GetSettingsCommunicationTemplatesIdData,
    type GetSettingsCommunicationTemplatesIdError,
    type GetSettingsCommunicationTemplatesIdErrors,
    type GetSettingsCommunicationTemplatesIdResponse,
    type GetSettingsCommunicationTemplatesIdResponses,
    type GetSettingsCommunicationTemplatesResponse,
    type GetSettingsCommunicationTemplatesResponses,
    type GetSourcingJobsData,
    type GetSourcingJobsError,
    type GetSourcingJobsErrors,
    type GetSourcingJobsResponse,
    type GetSourcingJobsResponses,
    type GetSseTestData,
    type GetSseTestError,
    type GetSseTestErrors,
    type GetSseTestResponse,
    type GetSseTestResponses,
    type GetSseV2Data,
    type GetSseV2Error,
    type GetSseV2Errors,
    type GetStorageAccessData,
    type GetStorageAccessError,
    type GetStorageAccessErrors,
    type GetStorageAccessResponse,
    type GetStorageAccessResponses,
    type GetStorageUploadData,
    type GetStorageUploadError,
    type GetStorageUploadErrors,
    type GetStorageUploadResponse,
    type GetStorageUploadResponses,
    type GetTemporalCheatDetectionConfigData,
    type GetTemporalCheatDetectionConfigError,
    type GetTemporalCheatDetectionConfigErrors,
    type GetTemporalCompaniesIdAgentMemoryFlagsData,
    type GetTemporalCompaniesIdAgentMemoryFlagsError,
    type GetTemporalCompaniesIdAgentMemoryFlagsErrors,
    type GetTemporalCompaniesIdAgentMemoryFlagsResponse,
    type GetTemporalCompaniesIdAgentMemoryFlagsResponses,
    type GetTemporalHiQuestionsData,
    type GetTemporalHiQuestionsError,
    type GetTemporalHiQuestionsErrors,
    type GetTemporalHiQuestionsResponse,
    type GetTemporalHiQuestionsResponses,
    type GetTemporalIntegrationsData,
    type GetTemporalIntegrationsError,
    type GetTemporalIntegrationsErrors,
    type GetTemporalIntegrationsResponse,
    type GetTemporalIntegrationsResponses,
    type GetTemporalInterviewQualityCheckData,
    type GetTemporalInterviewQualityCheckError,
    type GetTemporalInterviewQualityCheckErrors,
    type GetTemporalInterviewQualityCheckResponse,
    type GetTemporalInterviewQualityCheckResponses,
    type GetTemporalInterviewQualityContextData,
    type GetTemporalInterviewQualityContextError,
    type GetTemporalInterviewQualityContextErrors,
    type GetTemporalInterviewQualityContextResponse,
    type GetTemporalInterviewQualityContextResponses,
    type GetTemporalJobApplicationsIdData,
    type GetTemporalJobApplicationsIdError,
    type GetTemporalJobApplicationsIdErrors,
    type GetTemporalJobApplicationsIdResponse,
    type GetTemporalJobApplicationsIdResponses,
    type GetTemporalJobApplicationsStatusData,
    type GetTemporalJobApplicationsStatusError,
    type GetTemporalJobApplicationsStatusErrors,
    type GetTemporalJobApplicationsStatusResponse,
    type GetTemporalJobApplicationsStatusResponses,
    type GetTemporalJobsIdData,
    type GetTemporalJobsIdError,
    type GetTemporalJobsIdErrors,
    type GetTemporalJobsIdResponse,
    type GetTemporalJobsIdResponses,
    type GetTemporalScreeningCallData,
    type GetTemporalScreeningCallError,
    type GetTemporalScreeningCallErrors,
    type GetTemporalScreeningCallResponse,
    type GetTemporalScreeningCallResponses,
    type GetTemporalScreeningInterviewData,
    type GetTemporalScreeningInterviewError,
    type GetTemporalScreeningInterviewErrors,
    type GetTemporalScreeningInterviewResponse,
    type GetTemporalScreeningInterviewResponses,
    type GetUserDataData,
    type GetUserDataError,
    type GetUserDataErrors,
    type GetWebhooksAzureEmailData,
    type GetWebhooksAzureEmailError,
    type GetWebhooksAzureEmailErrors,
    type GetWebhooksGraphData,
    type GetWebhooksGraphError,
    type GetWebhooksGraphErrors,
    type GetWebhooksGraphResponse,
    type GetWebhooksGraphResponses,
    type GetWebhooksGraphTranscriptData,
    type GetWebhooksGraphTranscriptError,
    type GetWebhooksGraphTranscriptErrors,
    type GetWebhooksGraphTranscriptResponse,
    type GetWebhooksGraphTranscriptResponses,
    type GetWebhooksPlivoVoiceData,
    type GetWebhooksPlivoVoiceError,
    type GetWebhooksPlivoVoiceErrors,
    type GetWebhooksPlivoVoiceResponse,
    type GetWebhooksPlivoVoiceResponses,
    type GetWebhooksPlivoWhatsappData,
    type GetWebhooksPlivoWhatsappError,
    type GetWebhooksPlivoWhatsappErrors,
    type GetWebhooksTwilioWhatsappData,
    type GetWebhooksTwilioWhatsappError,
    type GetWebhooksTwilioWhatsappErrors,
    type GetWellKnownScreeningJwksData,
    type GetWellKnownScreeningJwksError,
    type GetWellKnownScreeningJwksErrors,
    type GetWellKnownScreeningJwksResponse,
    type GetWellKnownScreeningJwksResponses,
    type GetWhatsappCompanySlugData,
    type GetWhatsappCompanySlugError,
    type GetWhatsappCompanySlugErrors,
    type GetWhatsappCompanySlugResponses,
    type GetWhatsappData,
    type GetWhatsappError,
    type GetWhatsappErrors,
    type GetWhatsappResponses,
    type GradeOptionSchema,
    type HeadInterviewsScreeningWebrtcNetworkProbeData,
    type HeadInterviewsScreeningWebrtcNetworkProbeError,
    type HeadInterviewsScreeningWebrtcNetworkProbeErrors,
    type IntegrationBodySchema,
    IntervalSchema,
    type IssueSchema,
    JdStatusSchema,
    type JobActivityApiResponseSchema,
    type JobActivityItemSchema,
    type JobActivityParamsSchema,
    type JobActivityQueryParamsSchema,
    type JobApplicationApplicantHistoryResponseSchema,
    type JobApplicationIdParamsSchema,
    type JobApplicationMessageResponseSchema,
    type JobApplicationReprocessResponseSchema,
    type JobApplicationsListQueryParamsSchema,
    type JobApplicationsListResponseSchema,
    type JobApplicationsProcessingQueryParamsSchema,
    type JobApplicationsProcessingResponseSchema,
    type JobCandidateMatchingQueryParamsSchema,
    type JobCandidateMatchingResponseSchema,
    type JobDescriptionApiResponseSchema,
    type JobDescriptionByIdQuerySchema,
    type JobDescriptionDeleteApiResponseSchema,
    type JobDescriptionIdParamsSchema,
    type JobDescriptionLinkedJobsApiResponseSchema,
    type JobDescriptionLinkedJobSchema,
    type JobDescriptionSchema,
    type JobDescriptionsListApiResponseSchema,
    type JobDescriptionsListQuerySchema,
    type JobDetailQueryParamsSchema,
    type JobIdParams,
    type JobIdParamsSchema,
    type JobPostingConfigApiResponseSchema,
    type JobPostingConfigBodySchema,
    type JobPostingConfigParamsSchema,
    type JobPostingConfigPayloadSchema,
    type JobsErrorSchema,
    type JobsListQueryParamsSchema,
    type JobsListResponseSchema,
    type JobSourcedCandidateApiResponseSchema,
    type JobSourcedCandidateDeleteApiResponseSchema,
    type JobSourcedCandidateInviteDraftApiResponseSchema,
    type JobSourcedCandidateInviteDraftBodySchema,
    type JobSourcedCandidateInviteEmailApiResponseSchema,
    type JobSourcedCandidateInviteEmailBodySchema,
    type JobSourcedCandidateInviteEmailPreviewApiResponseSchema,
    type JobSourcedCandidateInviteEmailPreviewBodySchema,
    type JobSourcedCandidateMoveApiResponseSchema,
    type JobSourcedCandidateParamsSchema,
    type JobSourcedCandidateRowSchema,
    type JobSourcedCandidatesApiResponseSchema,
    type JobSourcedCandidatesParamsSchema,
    type JobSourcedCandidatesQueryParamsSchema,
    type JobSourcedCandidateUpdateBodySchema,
    type JsonValueSchema,
    type LimitsSchema,
    type LinkBodySchema,
    type MixableRolesSchema,
    type MyCompaniesApiResponseSchema,
    type MyCompanyPayloadSchema,
    type ObjectiveEvaluationSchema,
    type ObjectSchema,
    type OnboardingCompleteCheckoutApiResponseSchema,
    type OnboardingCompleteCheckoutBodySchema,
    type OnboardingCompleteCheckoutPayloadSchema,
    type OnboardingDraftApiResponseSchema,
    type OnboardingDraftPlanSchema,
    type OnboardingDraftSchema,
    type OnboardingOrgBodySchema,
    type OnboardingPlansApiResponseSchema,
    type OnboardingPublicPlanSchema,
    type OnboardingSelectPlanApiResponseSchema,
    type OnboardingSelectPlanBodySchema,
    type OnboardingSelectPlanCheckoutSchema,
    type OnboardingSelectPlanProvisionedSchema,
    type OnboardingSignupCompleteSchema,
    type OnboardingSignupSchema,
    type OnboardingSignupStartApiResponseSchema,
    type OnboardingSignupStartResponseSchema,
    type OnboardingSignupStartSchema,
    type OnboardingUploadLogoApiResponseSchema,
    type OnboardingUploadLogoMultipartSchema,
    type OnboardingUploadLogoPayloadSchema,
    type OnboardingVerifyCodeBodySchema,
    type OnboardingVerifyStatusResendApiResponseSchema,
    type OnboardingVerifyStatusResendSchema,
    type OptionalNumber,
    type OptionSchema,
    type OrgConfigBodySchema,
    type OrgConfigFormSchema,
    type PaginationModelParam,
    type PanellistsApiResponseSchema,
    type PanellistSchema,
    type PanellistsPayloadSchema,
    type PanellistsQueryParamsSchema,
    type PatchAdminBillingPlansIdData,
    type PatchAdminBillingPlansIdError,
    type PatchAdminBillingPlansIdErrors,
    type PatchAdminBillingPlansIdResponse,
    type PatchAdminBillingPlansIdResponses,
    type PatchAdminCompaniesIdArchiveData,
    type PatchAdminCompaniesIdArchiveError,
    type PatchAdminCompaniesIdArchiveErrors,
    type PatchAdminCompaniesIdArchiveResponse,
    type PatchAdminCompaniesIdArchiveResponses,
    type PatchAdminCompaniesIdBillingData,
    type PatchAdminCompaniesIdBillingError,
    type PatchAdminCompaniesIdBillingErrors,
    type PatchAdminCompaniesIdBillingResponse,
    type PatchAdminCompaniesIdBillingResponses,
    type PatchAdminCompaniesIdFeatureFlagsData,
    type PatchAdminCompaniesIdFeatureFlagsError,
    type PatchAdminCompaniesIdFeatureFlagsErrors,
    type PatchAdminCompaniesIdFeatureFlagsResponse,
    type PatchAdminCompaniesIdFeatureFlagsResponses,
    type PatchAdminCompaniesIdIntegrationsData,
    type PatchAdminCompaniesIdIntegrationsError,
    type PatchAdminCompaniesIdIntegrationsErrors,
    type PatchAdminCompaniesIdIntegrationsResponse,
    type PatchAdminCompaniesIdIntegrationsResponses,
    type PatchAdminCompaniesIdOrgConfigData,
    type PatchAdminCompaniesIdOrgConfigError,
    type PatchAdminCompaniesIdOrgConfigErrors,
    type PatchAdminCompaniesIdOrgConfigResponse,
    type PatchAdminCompaniesIdOrgConfigResponses,
    type PatchAdminInterviewQualityIssuesIdData,
    type PatchAdminInterviewQualityIssuesIdError,
    type PatchAdminInterviewQualityIssuesIdErrors,
    type PatchAdminInterviewQualityIssuesIdResponse,
    type PatchAdminInterviewQualityIssuesIdResponses,
    type PatchAutoApproveSchema,
    type PatchBodySchema,
    type PatchCalendarGenerateTranscriptData,
    type PatchCalendarGenerateTranscriptError,
    type PatchCalendarGenerateTranscriptErrors,
    type PatchCompanyCompanySlugApprovalFlowData,
    type PatchCompanyCompanySlugApprovalFlowError,
    type PatchCompanyCompanySlugApprovalFlowErrors,
    type PatchCompanyCompanySlugApprovalFlowResponse,
    type PatchCompanyCompanySlugApprovalFlowResponses,
    type PatchCompanyCompanySlugApprovalFlowRuleIdData,
    type PatchCompanyCompanySlugApprovalFlowRuleIdError,
    type PatchCompanyCompanySlugApprovalFlowRuleIdErrors,
    type PatchCompanyCompanySlugApprovalFlowRuleIdResponse,
    type PatchCompanyCompanySlugApprovalFlowRuleIdResponses,
    type PatchCompanyCompanySlugCandidateStatusesConfigStatusIdData,
    type PatchCompanyCompanySlugCandidateStatusesConfigStatusIdError,
    type PatchCompanyCompanySlugCandidateStatusesConfigStatusIdErrors,
    type PatchCompanyCompanySlugCandidateStatusesConfigStatusIdResponse,
    type PatchCompanyCompanySlugCandidateStatusesConfigStatusIdResponses,
    type PatchCompanyCompanySlugDepartmentsData,
    type PatchCompanyCompanySlugDepartmentsError,
    type PatchCompanyCompanySlugDepartmentsErrors,
    type PatchCompanyCompanySlugDepartmentsResponse,
    type PatchCompanyCompanySlugDepartmentsResponses,
    type PatchCompanyCompanySlugIntegrationsData,
    type PatchCompanyCompanySlugIntegrationsError,
    type PatchCompanyCompanySlugIntegrationsErrors,
    type PatchCompanyCompanySlugIntegrationsResponse,
    type PatchCompanyCompanySlugIntegrationsResponses,
    type PatchCompanyCompanySlugScreeningWebrtcConfigData,
    type PatchCompanyCompanySlugScreeningWebrtcConfigError,
    type PatchCompanyCompanySlugScreeningWebrtcConfigErrors,
    type PatchCompanyCompanySlugScreeningWebrtcConfigResponse,
    type PatchCompanyCompanySlugScreeningWebrtcConfigResponses,
    type PatchCompanyCompanySlugUsersUserIdData,
    type PatchCompanyCompanySlugUsersUserIdError,
    type PatchCompanyCompanySlugUsersUserIdErrors,
    type PatchCompanyCompanySlugUsersUserIdResponse,
    type PatchCompanyCompanySlugUsersUserIdResponses,
    type PatchCronCandidatesData,
    type PatchCronCandidatesError,
    type PatchCronCandidatesErrors,
    type PatchCustomAnalyticsDashboardData,
    type PatchCustomAnalyticsDashboardError,
    type PatchCustomAnalyticsDashboardErrors,
    type PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryData,
    type PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryError,
    type PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryErrors,
    type PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryResponse,
    type PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryResponses,
    type PatchJdIdData,
    type PatchJdIdError,
    type PatchJdIdErrors,
    type PatchJdIdResponse,
    type PatchJdIdResponses,
    type PatchJobApplicationsData,
    type PatchJobApplicationsError,
    type PatchJobApplicationsErrors,
    type PatchJobApplicationsResponse,
    type PatchJobApplicationsResponses,
    type PatchJobApplicationsStatusData,
    type PatchJobApplicationsStatusError,
    type PatchJobApplicationsStatusErrors,
    type PatchJobApplicationsStatusResponse,
    type PatchJobApplicationsStatusResponses,
    type PatchJobOpeningsIdData,
    type PatchJobOpeningsIdError,
    type PatchJobOpeningsIdErrors,
    type PatchJobsIdSourcedCandidatesSourcedCandidateIdData,
    type PatchJobsIdSourcedCandidatesSourcedCandidateIdError,
    type PatchJobsIdSourcedCandidatesSourcedCandidateIdErrors,
    type PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdData,
    type PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdError,
    type PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdErrors,
    type PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdResponse,
    type PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdResponses,
    type PatchJobsIdSourcedCandidatesSourcedCandidateIdResponse,
    type PatchJobsIdSourcedCandidatesSourcedCandidateIdResponses,
    type PatchJobsIdStatusData,
    type PatchJobsIdStatusError,
    type PatchJobsIdStatusErrors,
    type PatchJobsIdStatusResponse,
    type PatchJobsIdStatusResponses,
    type PatchOnboardingOrgData,
    type PatchOnboardingOrgError,
    type PatchOnboardingOrgErrors,
    type PatchOnboardingOrgResponse,
    type PatchOnboardingOrgResponses,
    type PatchStatusSchema,
    type PhoneScreeningConfigSchema,
    type PlanCodeSchema,
    type PlanFormSchema,
    type PostAdminBillingCreditCostsData,
    type PostAdminBillingCreditCostsError,
    type PostAdminBillingCreditCostsErrors,
    type PostAdminBillingCreditCostsImportData,
    type PostAdminBillingCreditCostsImportError,
    type PostAdminBillingCreditCostsImportErrors,
    type PostAdminBillingCreditCostsImportResponse,
    type PostAdminBillingCreditCostsImportResponses,
    type PostAdminBillingCreditCostsResponse,
    type PostAdminBillingCreditCostsResponses,
    type PostAdminBillingPlansData,
    type PostAdminBillingPlansError,
    type PostAdminBillingPlansErrors,
    type PostAdminBillingPlansIdSyncData,
    type PostAdminBillingPlansIdSyncError,
    type PostAdminBillingPlansIdSyncErrors,
    type PostAdminBillingPlansIdSyncResponse,
    type PostAdminBillingPlansIdSyncResponses,
    type PostAdminBillingPlansImportData,
    type PostAdminBillingPlansImportError,
    type PostAdminBillingPlansImportErrors,
    type PostAdminBillingPlansImportResponse,
    type PostAdminBillingPlansImportResponses,
    type PostAdminBillingPlansResponse,
    type PostAdminBillingPlansResponses,
    type PostAdminCompaniesData,
    type PostAdminCompaniesError,
    type PostAdminCompaniesErrors,
    type PostAdminCompaniesIdCreditsData,
    type PostAdminCompaniesIdCreditsError,
    type PostAdminCompaniesIdCreditsErrors,
    type PostAdminCompaniesIdCreditsResponse,
    type PostAdminCompaniesIdCreditsResponses,
    type PostAdminCompaniesIdIntegrationsData,
    type PostAdminCompaniesIdIntegrationsError,
    type PostAdminCompaniesIdIntegrationsErrors,
    type PostAdminCompaniesIdIntegrationsIntegrationIdReencryptData,
    type PostAdminCompaniesIdIntegrationsIntegrationIdReencryptError,
    type PostAdminCompaniesIdIntegrationsIntegrationIdReencryptErrors,
    type PostAdminCompaniesIdIntegrationsIntegrationIdReencryptResponse,
    type PostAdminCompaniesIdIntegrationsIntegrationIdReencryptResponses,
    type PostAdminCompaniesIdIntegrationsResponse,
    type PostAdminCompaniesIdIntegrationsResponses,
    type PostAdminCompaniesIdLinkIntalentUserData,
    type PostAdminCompaniesIdLinkIntalentUserError,
    type PostAdminCompaniesIdLinkIntalentUserErrors,
    type PostAdminCompaniesIdLinkIntalentUserResponse,
    type PostAdminCompaniesIdLinkIntalentUserResponses,
    type PostAdminCompaniesResponse,
    type PostAdminCompaniesResponses,
    type PostAdminInterviewQualityResolveData,
    type PostAdminInterviewQualityResolveError,
    type PostAdminInterviewQualityResolveErrors,
    type PostAdminInterviewQualityResolveResponse,
    type PostAdminInterviewQualityResolveResponses,
    type PostAdminInterviewQualityRunsData,
    type PostAdminInterviewQualityRunsError,
    type PostAdminInterviewQualityRunsErrors,
    type PostAdminInterviewQualityRunsResponse,
    type PostAdminInterviewQualityRunsResponses,
    type PostAdminOrganizationsData,
    type PostAdminOrganizationsError,
    type PostAdminOrganizationsErrors,
    type PostAdminOrganizationsResponse,
    type PostAdminOrganizationsResponses,
    type PostAdminOrganizationsUploadLogoData,
    type PostAdminOrganizationsUploadLogoError,
    type PostAdminOrganizationsUploadLogoErrors,
    type PostAdminOrganizationsUploadLogoResponse,
    type PostAdminOrganizationsUploadLogoResponses,
    type PostAnalyticsAgentData,
    type PostAnalyticsAgentError,
    type PostAnalyticsAgentErrors,
    type PostAnalyticsAgentResponse,
    type PostAnalyticsAgentResponses,
    type PostAnalyticsAgentStreamData,
    type PostAnalyticsAgentStreamError,
    type PostAnalyticsAgentStreamErrors,
    type PostAnalyticsAgentStreamResponse,
    type PostAnalyticsAgentStreamResponses,
    type PostAssessmentParamsData,
    type PostAssessmentParamsError,
    type PostAssessmentParamsErrors,
    type PostAssessmentParamsIdCopyData,
    type PostAssessmentParamsIdCopyError,
    type PostAssessmentParamsIdCopyErrors,
    type PostAssessmentParamsIdCopyResponse,
    type PostAssessmentParamsIdCopyResponses,
    type PostAssessmentParamsResponse,
    type PostAssessmentParamsResponses,
    type PostAssessmentTemplatesData,
    type PostAssessmentTemplatesError,
    type PostAssessmentTemplatesErrors,
    type PostAssessmentTemplatesResponse,
    type PostAssessmentTemplatesResponses,
    type PostAuthSetCompanyData,
    type PostAuthSetCompanyError,
    type PostAuthSetCompanyErrors,
    type PostAuthSetCompanyResponse,
    type PostAuthSetCompanyResponses,
    type PostBillingChangePlanData,
    type PostBillingChangePlanError,
    type PostBillingChangePlanErrors,
    type PostBillingChangePlanResponse,
    type PostBillingChangePlanResponses,
    type PostBillingCompleteCheckoutData,
    type PostBillingCompleteCheckoutError,
    type PostBillingCompleteCheckoutErrors,
    type PostBillingCompleteCheckoutResponse,
    type PostBillingCompleteCheckoutResponses,
    type PostBillingCreditPacksData,
    type PostBillingCreditPacksError,
    type PostBillingCreditPacksErrors,
    type PostBillingPortalData,
    type PostBillingPortalError,
    type PostBillingPortalErrors,
    type PostBillingPortalResponse,
    type PostBillingPortalResponses,
    type PostCalendarAvailabilityData,
    type PostCalendarAvailabilityError,
    type PostCalendarAvailabilityErrors,
    type PostCalendarData,
    type PostCalendarError,
    type PostCalendarErrors,
    type PostCalendarGenerateTranscriptData,
    type PostCalendarGenerateTranscriptError,
    type PostCalendarGenerateTranscriptErrors,
    type PostCalendarPanelistSlotsCommentsData,
    type PostCalendarPanelistSlotsCommentsError,
    type PostCalendarPanelistSlotsCommentsErrors,
    type PostCalendarPanelistSlotsData,
    type PostCalendarPanelistSlotsError,
    type PostCalendarPanelistSlotsErrors,
    type PostCalendarPanelistSlotsGenerateData,
    type PostCalendarPanelistSlotsGenerateError,
    type PostCalendarPanelistSlotsGenerateErrors,
    type PostCalendarSchedulingSlotsData,
    type PostCalendarSchedulingSlotsError,
    type PostCalendarSchedulingSlotsErrors,
    type PostCandidatesBulkDeleteData,
    type PostCandidatesBulkDeleteError,
    type PostCandidatesBulkDeleteErrors,
    type PostCandidatesBulkDeleteResponse,
    type PostCandidatesBulkDeleteResponses,
    type PostCandidatesData,
    type PostCandidatesError,
    type PostCandidatesErrors,
    type PostCandidatesParseQueryData,
    type PostCandidatesParseQueryError,
    type PostCandidatesParseQueryErrors,
    type PostCandidatesParseQueryResponse,
    type PostCandidatesParseQueryResponses,
    type PostCandidatesResponse,
    type PostCandidatesResponses,
    type PostCompanyCompanySlugApprovalFlowData,
    type PostCompanyCompanySlugApprovalFlowError,
    type PostCompanyCompanySlugApprovalFlowErrors,
    type PostCompanyCompanySlugApprovalFlowResponse,
    type PostCompanyCompanySlugApprovalFlowResponses,
    type PostCompanyCompanySlugCandidateStatusesConfigData,
    type PostCompanyCompanySlugCandidateStatusesConfigError,
    type PostCompanyCompanySlugCandidateStatusesConfigErrors,
    type PostCompanyCompanySlugCandidateStatusesConfigResponse,
    type PostCompanyCompanySlugCandidateStatusesConfigResponses,
    type PostCompanyCompanySlugDepartmentsData,
    type PostCompanyCompanySlugDepartmentsError,
    type PostCompanyCompanySlugDepartmentsErrors,
    type PostCompanyCompanySlugDepartmentsResponse,
    type PostCompanyCompanySlugDepartmentsResponses,
    type PostCompanyCompanySlugIntegrationsDisconnectData,
    type PostCompanyCompanySlugIntegrationsDisconnectError,
    type PostCompanyCompanySlugIntegrationsDisconnectErrors,
    type PostCompanyCompanySlugIntegrationsDisconnectResponse,
    type PostCompanyCompanySlugIntegrationsDisconnectResponses,
    type PostCompanyCompanySlugIntegrationsLinkedinVerifyData,
    type PostCompanyCompanySlugIntegrationsLinkedinVerifyError,
    type PostCompanyCompanySlugIntegrationsLinkedinVerifyErrors,
    type PostCompanyCompanySlugIntegrationsLinkedinVerifyResponse,
    type PostCompanyCompanySlugIntegrationsLinkedinVerifyResponses,
    type PostCompanyCompanySlugIntegrationsTestData,
    type PostCompanyCompanySlugIntegrationsTestError,
    type PostCompanyCompanySlugIntegrationsTestErrors,
    type PostCompanyCompanySlugIntegrationsTestResponse,
    type PostCompanyCompanySlugIntegrationsTestResponses,
    type PostCompanyCompanySlugLogoData,
    type PostCompanyCompanySlugLogoError,
    type PostCompanyCompanySlugLogoErrors,
    type PostCompanyCompanySlugLogoResponse,
    type PostCompanyCompanySlugLogoResponses,
    type PostCompanyCompanySlugUsersData,
    type PostCompanyCompanySlugUsersDisableData,
    type PostCompanyCompanySlugUsersDisableError,
    type PostCompanyCompanySlugUsersDisableErrors,
    type PostCompanyCompanySlugUsersDisableResponse,
    type PostCompanyCompanySlugUsersDisableResponses,
    type PostCompanyCompanySlugUsersEnableData,
    type PostCompanyCompanySlugUsersEnableError,
    type PostCompanyCompanySlugUsersEnableErrors,
    type PostCompanyCompanySlugUsersEnableResponse,
    type PostCompanyCompanySlugUsersEnableResponses,
    type PostCompanyCompanySlugUsersError,
    type PostCompanyCompanySlugUsersErrors,
    type PostCompanyCompanySlugUsersResponse,
    type PostCompanyCompanySlugUsersResponses,
    type PostCompanyCompanySlugUsersUserIdResetPasswordData,
    type PostCompanyCompanySlugUsersUserIdResetPasswordError,
    type PostCompanyCompanySlugUsersUserIdResetPasswordErrors,
    type PostCompanyCompanySlugUsersUserIdResetPasswordResponse,
    type PostCompanyCompanySlugUsersUserIdResetPasswordResponses,
    type PostCompanyConfigData,
    type PostCompanyConfigError,
    type PostCompanyConfigErrors,
    type PostCompanyConfigResponse,
    type PostCompanyConfigResponses,
    type PostCompanyGradeData,
    type PostCompanyGradeError,
    type PostCompanyGradeErrors,
    type PostCompanyGradeResponse,
    type PostCompanyGradeResponses,
    type PostCompanySlugCandidateSharingCreateData,
    type PostCompanySlugCandidateSharingCreateError,
    type PostCompanySlugCandidateSharingCreateErrors,
    type PostCompanySlugJobsJobPostingIdTalentPoolInvitesData,
    type PostCompanySlugJobsJobPostingIdTalentPoolInvitesError,
    type PostCompanySlugJobsJobPostingIdTalentPoolInvitesErrors,
    type PostCompanySlugPublicCareerJobsIdApplicationsData,
    type PostCompanySlugPublicCareerJobsIdApplicationsError,
    type PostCompanySlugPublicCareerJobsIdApplicationsErrors,
    type PostCompanySlugPublicCareerJobsIdApplicationsResponse,
    type PostCompanySlugPublicCareerJobsIdApplicationsResponses,
    type PostCompanySlugPublicCareerTalentPoolApplicationsData,
    type PostCompanySlugPublicCareerTalentPoolApplicationsError,
    type PostCompanySlugPublicCareerTalentPoolApplicationsErrors,
    type PostCompanySlugPublicCareerTalentPoolApplicationsResponse,
    type PostCompanySlugPublicCareerTalentPoolApplicationsResponses,
    type PostCompanyTitleGradeData,
    type PostCompanyTitleGradeError,
    type PostCompanyTitleGradeErrors,
    type PostCompanyTitleGradeResponse,
    type PostCompanyTitleGradeResponses,
    type PostCronAiInterviewRemindersData,
    type PostCronAiInterviewRemindersError,
    type PostCronAiInterviewRemindersErrors,
    type PostCronAnalyticsRefreshData,
    type PostCronAnalyticsRefreshError,
    type PostCronAnalyticsRefreshErrors,
    type PostCronBillingCapacityRebillData,
    type PostCronBillingCapacityRebillError,
    type PostCronBillingCapacityRebillErrors,
    type PostCronFeedbackRemindersData,
    type PostCronFeedbackRemindersError,
    type PostCronFeedbackRemindersErrors,
    type PostCronJobApplicationProcessingData,
    type PostCronJobApplicationProcessingError,
    type PostCronJobApplicationProcessingErrors,
    type PostCronJobApplicationProcessingResponse,
    type PostCronJobApplicationProcessingResponses,
    type PostCronRenewCalendarSubscriptionsData,
    type PostCronRenewCalendarSubscriptionsError,
    type PostCronRenewCalendarSubscriptionsErrors,
    type PostCronScreeningWebrtcLifecycleSweeperData,
    type PostCronScreeningWebrtcLifecycleSweeperError,
    type PostCronScreeningWebrtcLifecycleSweeperErrors,
    type PostCustomAnalyticsAssignDashboardData,
    type PostCustomAnalyticsAssignDashboardError,
    type PostCustomAnalyticsAssignDashboardErrors,
    type PostCustomAnalyticsDashboardData,
    type PostCustomAnalyticsDashboardError,
    type PostCustomAnalyticsDashboardErrors,
    type PostCustomAnalyticsData,
    type PostCustomAnalyticsError,
    type PostCustomAnalyticsErrors,
    type PostCustomAnalyticsOrderData,
    type PostCustomAnalyticsOrderError,
    type PostCustomAnalyticsOrderErrors,
    type PostCustomAnalyticsPaginateData,
    type PostCustomAnalyticsPaginateError,
    type PostCustomAnalyticsPaginateErrors,
    type PostCustomAnalyticsPreviewData,
    type PostCustomAnalyticsPreviewError,
    type PostCustomAnalyticsPreviewErrors,
    type PostCustomAnalyticsRemoveDashboardData,
    type PostCustomAnalyticsRemoveDashboardError,
    type PostCustomAnalyticsRemoveDashboardErrors,
    type PostEmbeddingsData,
    type PostEmbeddingsError,
    type PostEmbeddingsErrors,
    type PostEmbeddingsResponse,
    type PostEmbeddingsResponses,
    type PostGenerateQuestionsData,
    type PostGenerateQuestionsError,
    type PostGenerateQuestionsErrors,
    type PostHiringManagersData,
    type PostHiringManagersError,
    type PostHiringManagersErrors,
    type PostInsightsBenettonApplicantsReportData,
    type PostInsightsBenettonApplicantsReportError,
    type PostInsightsBenettonApplicantsReportErrors,
    type PostInsightsCandidatesByRolesReportData,
    type PostInsightsCandidatesByRolesReportError,
    type PostInsightsCandidatesByRolesReportErrors,
    type PostInsightsCandidatesByStatusReportData,
    type PostInsightsCandidatesByStatusReportError,
    type PostInsightsCandidatesByStatusReportErrors,
    type PostInsightsCustomChartsData,
    type PostInsightsCustomChartsError,
    type PostInsightsCustomChartsErrors,
    type PostInsightsMonthlyDashboardData,
    type PostInsightsMonthlyDashboardError,
    type PostInsightsMonthlyDashboardErrors,
    type PostInsightsOfferJoinedReportData,
    type PostInsightsOfferJoinedReportError,
    type PostInsightsOfferJoinedReportErrors,
    type PostInsightsOpenPositionsReportData,
    type PostInsightsOpenPositionsReportError,
    type PostInsightsOpenPositionsReportErrors,
    type PostInsightsPositionsClosedReportData,
    type PostInsightsPositionsClosedReportError,
    type PostInsightsPositionsClosedReportErrors,
    type PostInsightsPositionsCreatedReportData,
    type PostInsightsPositionsCreatedReportError,
    type PostInsightsPositionsCreatedReportErrors,
    type PostInsightsPredefinedGraphsData,
    type PostInsightsPredefinedGraphsError,
    type PostInsightsPredefinedGraphsErrors,
    type PostInsightsPredefinedGraphsSaveData,
    type PostInsightsPredefinedGraphsSaveError,
    type PostInsightsPredefinedGraphsSaveErrors,
    type PostInternalAnalyticsQueryData,
    type PostInternalAnalyticsQueryError,
    type PostInternalAnalyticsQueryErrors,
    type PostInternalAnalyticsQueryResponse,
    type PostInternalAnalyticsQueryResponses,
    type PostInternalSttData,
    type PostInternalSttError,
    type PostInternalSttErrors,
    type PostInternalSttResponse,
    type PostInternalSttResponses,
    type PostInterviewsData,
    type PostInterviewsError,
    type PostInterviewsErrors,
    type PostInterviewsFeedbackGenerateData,
    type PostInterviewsFeedbackGenerateError,
    type PostInterviewsFeedbackGenerateErrors,
    type PostInterviewsHumanInterviewQuestionsData,
    type PostInterviewsHumanInterviewQuestionsError,
    type PostInterviewsHumanInterviewQuestionsErrors,
    type PostInterviewsHumanInterviewQuestionsTriggerData,
    type PostInterviewsHumanInterviewQuestionsTriggerError,
    type PostInterviewsHumanInterviewQuestionsTriggerErrors,
    type PostInterviewsIdInterviewRoundData,
    type PostInterviewsIdInterviewRoundError,
    type PostInterviewsIdInterviewRoundErrors,
    type PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryData,
    type PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryError,
    type PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryErrors,
    type PostInterviewsIdInterviewRoundInterviewRoundIdRatingsData,
    type PostInterviewsIdInterviewRoundInterviewRoundIdRatingsError,
    type PostInterviewsIdInterviewRoundInterviewRoundIdRatingsErrors,
    type PostInterviewsIdInterviewRoundResponse,
    type PostInterviewsIdInterviewRoundResponses,
    type PostInterviewsResponse,
    type PostInterviewsResponses,
    type PostInterviewsScreeningCallBulkData,
    type PostInterviewsScreeningCallBulkError,
    type PostInterviewsScreeningCallBulkErrors,
    type PostInterviewsScreeningCallData,
    type PostInterviewsScreeningCallEndInterviewData,
    type PostInterviewsScreeningCallEndInterviewError,
    type PostInterviewsScreeningCallEndInterviewErrors,
    type PostInterviewsScreeningCallEndInterviewResponse,
    type PostInterviewsScreeningCallEndInterviewResponses,
    type PostInterviewsScreeningCallError,
    type PostInterviewsScreeningCallErrors,
    type PostInterviewsScreeningCallIdRecordingFetchData,
    type PostInterviewsScreeningCallIdRecordingFetchError,
    type PostInterviewsScreeningCallIdRecordingFetchErrors,
    type PostInterviewsScreeningCallIdRecordingFetchResponse,
    type PostInterviewsScreeningCallIdRecordingFetchResponses,
    type PostInterviewsScreeningCallLifecycleData,
    type PostInterviewsScreeningCallLifecycleError,
    type PostInterviewsScreeningCallLifecycleErrors,
    type PostInterviewsScreeningCallLifecycleResponse,
    type PostInterviewsScreeningCallLifecycleResponses,
    type PostInterviewsScreeningInterviewClientTokenData,
    type PostInterviewsScreeningInterviewClientTokenError,
    type PostInterviewsScreeningInterviewClientTokenErrors,
    type PostInterviewsScreeningInterviewClientTokenResponse,
    type PostInterviewsScreeningInterviewClientTokenResponses,
    type PostInterviewsScreeningInterviewDailyRecordingData,
    type PostInterviewsScreeningInterviewDailyRecordingError,
    type PostInterviewsScreeningInterviewDailyRecordingErrors,
    type PostInterviewsScreeningInterviewData,
    type PostInterviewsScreeningInterviewEndInterviewData,
    type PostInterviewsScreeningInterviewEndInterviewError,
    type PostInterviewsScreeningInterviewEndInterviewErrors,
    type PostInterviewsScreeningInterviewEndInterviewResponse,
    type PostInterviewsScreeningInterviewEndInterviewResponses,
    type PostInterviewsScreeningInterviewError,
    type PostInterviewsScreeningInterviewErrors,
    type PostInterviewsScreeningInterviewEventsData,
    type PostInterviewsScreeningInterviewEventsError,
    type PostInterviewsScreeningInterviewEventsErrors,
    type PostInterviewsScreeningInterviewEventsResponse,
    type PostInterviewsScreeningInterviewEventsResponses,
    type PostInterviewsScreeningInterviewFastrtcRecordingData,
    type PostInterviewsScreeningInterviewFastrtcRecordingError,
    type PostInterviewsScreeningInterviewFastrtcRecordingErrors,
    type PostInterviewsScreeningInterviewFetchDailyRecordingData,
    type PostInterviewsScreeningInterviewFetchDailyRecordingError,
    type PostInterviewsScreeningInterviewFetchDailyRecordingErrors,
    type PostInterviewsScreeningInterviewFixLivenessStatusData,
    type PostInterviewsScreeningInterviewFixLivenessStatusError,
    type PostInterviewsScreeningInterviewFixLivenessStatusErrors,
    type PostInterviewsScreeningInterviewProctoringData,
    type PostInterviewsScreeningInterviewProctoringError,
    type PostInterviewsScreeningInterviewProctoringErrors,
    type PostInterviewsScreeningInterviewProctoringResponse,
    type PostInterviewsScreeningInterviewProctoringResponses,
    type PostInterviewsScreeningInterviewStartData,
    type PostInterviewsScreeningInterviewStartError,
    type PostInterviewsScreeningInterviewStartErrors,
    type PostInterviewsScreeningInterviewTransitionToStartedData,
    type PostInterviewsScreeningInterviewTransitionToStartedError,
    type PostInterviewsScreeningInterviewTransitionToStartedErrors,
    type PostInterviewsScreeningInterviewTransitionToStartedResponse,
    type PostInterviewsScreeningInterviewTransitionToStartedResponses,
    type PostInterviewsScreeningInterviewTtsEnsureData,
    type PostInterviewsScreeningInterviewTtsEnsureError,
    type PostInterviewsScreeningInterviewTtsEnsureErrors,
    type PostInterviewsScreeningWebrtcAbandonData,
    type PostInterviewsScreeningWebrtcAbandonError,
    type PostInterviewsScreeningWebrtcAbandonErrors,
    type PostInterviewsScreeningWebrtcAbandonResponse,
    type PostInterviewsScreeningWebrtcAbandonResponses,
    type PostInterviewsScreeningWebrtcLifecycleData,
    type PostInterviewsScreeningWebrtcLifecycleError,
    type PostInterviewsScreeningWebrtcLifecycleErrors,
    type PostInterviewsScreeningWebrtcLifecycleResponse,
    type PostInterviewsScreeningWebrtcLifecycleResponses,
    type PostInterviewsScreeningWebrtcOfferData,
    type PostInterviewsScreeningWebrtcOfferError,
    type PostInterviewsScreeningWebrtcOfferErrors,
    type PostInterviewsScreeningWebrtcOfferResponse,
    type PostInterviewsScreeningWebrtcOfferResponses,
    type PostInterviewsScreeningWebrtcRecordingChunkData,
    type PostInterviewsScreeningWebrtcRecordingChunkError,
    type PostInterviewsScreeningWebrtcRecordingChunkErrors,
    type PostInterviewsScreeningWebrtcRecordingChunkResponse,
    type PostInterviewsScreeningWebrtcRecordingChunkResponses,
    type PostInterviewsScreeningWebrtcRecordingFinalizeData,
    type PostInterviewsScreeningWebrtcRecordingFinalizeError,
    type PostInterviewsScreeningWebrtcRecordingFinalizeErrors,
    type PostInterviewsScreeningWebrtcRecordingFinalizeResponse,
    type PostInterviewsScreeningWebrtcRecordingFinalizeResponses,
    type PostInterviewsScreeningWebrtcRecordingInitData,
    type PostInterviewsScreeningWebrtcRecordingInitError,
    type PostInterviewsScreeningWebrtcRecordingInitErrors,
    type PostInterviewsScreeningWebrtcRecordingInitResponse,
    type PostInterviewsScreeningWebrtcRecordingInitResponses,
    type PostInterviewsScreeningWebrtcRecordingPartUrlData,
    type PostInterviewsScreeningWebrtcRecordingPartUrlError,
    type PostInterviewsScreeningWebrtcRecordingPartUrlErrors,
    type PostInterviewsScreeningWebrtcRecordingPartUrlResponse,
    type PostInterviewsScreeningWebrtcRecordingPartUrlResponses,
    type PostInterviewsScreeningWebrtcSessionData,
    type PostInterviewsScreeningWebrtcSessionError,
    type PostInterviewsScreeningWebrtcSessionErrors,
    type PostInterviewsScreeningWebrtcSessionLogAppendData,
    type PostInterviewsScreeningWebrtcSessionLogAppendError,
    type PostInterviewsScreeningWebrtcSessionLogAppendErrors,
    type PostInterviewsScreeningWebrtcSessionLogAppendResponse,
    type PostInterviewsScreeningWebrtcSessionLogAppendResponses,
    type PostInterviewsScreeningWebrtcSessionLogFinalizeData,
    type PostInterviewsScreeningWebrtcSessionLogFinalizeError,
    type PostInterviewsScreeningWebrtcSessionLogFinalizeErrors,
    type PostInterviewsScreeningWebrtcSessionLogFinalizeResponse,
    type PostInterviewsScreeningWebrtcSessionLogFinalizeResponses,
    type PostInterviewsScreeningWebrtcSessionResponse,
    type PostInterviewsScreeningWebrtcSessionResponses,
    type PostInterviewsScreeningWebrtcSessionSessionIdConnectData,
    type PostInterviewsScreeningWebrtcSessionSessionIdConnectError,
    type PostInterviewsScreeningWebrtcSessionSessionIdConnectErrors,
    type PostInterviewsScreeningWebrtcSessionSessionIdConnectResponse,
    type PostInterviewsScreeningWebrtcSessionSessionIdConnectResponses,
    type PostInterviewsScreeningWebrtcTokenData,
    type PostInterviewsScreeningWebrtcTokenError,
    type PostInterviewsScreeningWebrtcTokenErrors,
    type PostInterviewsScreeningWebrtcTokenResponse,
    type PostInterviewsScreeningWebrtcTokenResponses,
    type PostJdAgentBackendData,
    type PostJdAgentBackendError,
    type PostJdAgentBackendErrors,
    type PostJdAgentBackendResponse,
    type PostJdAgentBackendResponses,
    type PostJdAgentBackendStreamData,
    type PostJdAgentBackendStreamError,
    type PostJdAgentBackendStreamErrors,
    type PostJdAgentBackendStreamResponse,
    type PostJdAgentBackendStreamResponses,
    type PostJdAgentConversationSyncData,
    type PostJdAgentConversationSyncError,
    type PostJdAgentConversationSyncErrors,
    type PostJdAgentConversationSyncResponse,
    type PostJdAgentConversationSyncResponses,
    type PostJdData,
    type PostJdError,
    type PostJdErrors,
    type PostJdExtractTextData,
    type PostJdExtractTextError,
    type PostJdExtractTextErrors,
    type PostJdExtractTextResponse,
    type PostJdExtractTextResponses,
    type PostJdResponse,
    type PostJdResponses,
    type PostJobApplicationsBulkDeleteData,
    type PostJobApplicationsBulkDeleteError,
    type PostJobApplicationsBulkDeleteErrors,
    type PostJobApplicationsBulkDeleteResponse,
    type PostJobApplicationsBulkDeleteResponses,
    type PostJobApplicationsBulkReprocessData,
    type PostJobApplicationsBulkReprocessError,
    type PostJobApplicationsBulkReprocessErrors,
    type PostJobApplicationsBulkReprocessResponse,
    type PostJobApplicationsBulkReprocessResponses,
    type PostJobApplicationsData,
    type PostJobApplicationsError,
    type PostJobApplicationsErrors,
    type PostJobApplicationsIdData,
    type PostJobApplicationsIdError,
    type PostJobApplicationsIdErrors,
    type PostJobApplicationsIdReprocessData,
    type PostJobApplicationsIdReprocessError,
    type PostJobApplicationsIdReprocessErrors,
    type PostJobApplicationsIdReprocessResponse,
    type PostJobApplicationsIdReprocessResponses,
    type PostJobApplicationsIdResponse,
    type PostJobApplicationsIdResponses,
    type PostJobApplicationsResponse,
    type PostJobApplicationsResponses,
    type PostJobApproversBypassIdData,
    type PostJobApproversBypassIdError,
    type PostJobApproversBypassIdErrors,
    type PostJobApproversData,
    type PostJobApproversError,
    type PostJobApproversErrors,
    type PostJobApproversReminderIdData,
    type PostJobApproversReminderIdError,
    type PostJobApproversReminderIdErrors,
    type PostJobApproversReminderIdResponse,
    type PostJobApproversReminderIdResponses,
    type PostJobApproversResponse,
    type PostJobApproversResponses,
    type PostJobsBulkDeleteData,
    type PostJobsBulkDeleteError,
    type PostJobsBulkDeleteErrors,
    type PostJobsBulkDeleteResponse,
    type PostJobsBulkDeleteResponses,
    type PostJobsData,
    type PostJobsError,
    type PostJobsErrors,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsData,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsError,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsErrors,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsResponse,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsResponses,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsData,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsError,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsErrors,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewData,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewError,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewErrors,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewResponse,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewResponses,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsResponse,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsResponses,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdMoveData,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdMoveError,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdMoveErrors,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdMoveResponse,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdMoveResponses,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdNotesData,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdNotesError,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdNotesErrors,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdNotesResponse,
    type PostJobsIdSourcedCandidatesSourcedCandidateIdNotesResponses,
    type PostJobsResponse,
    type PostJobsResponses,
    type PostMailboxMonitoringData,
    type PostMailboxMonitoringError,
    type PostMailboxMonitoringErrors,
    type PostMailboxMonitoringProcessData,
    type PostMailboxMonitoringProcessError,
    type PostMailboxMonitoringProcessErrors,
    type PostMarleeCommandData,
    type PostMarleeCommandError,
    type PostMarleeCommandErrors,
    type PostMarleeCommandResponse,
    type PostMarleeCommandResponses,
    type PostMarleeSessionData,
    type PostMarleeSessionError,
    type PostMarleeSessionErrors,
    type PostMarleeSessionResponse,
    type PostMarleeSessionResponses,
    type PostNaukriJobData,
    type PostNaukriJobError,
    type PostNaukriJobErrors,
    type PostNaukriJobResponse,
    type PostNaukriJobResponses,
    type PostNotesData,
    type PostNotesError,
    type PostNotesErrors,
    type PostOffersData,
    type PostOffersError,
    type PostOffersErrors,
    type PostOffersRemindData,
    type PostOffersRemindError,
    type PostOffersRemindErrors,
    type PostOffersRemindResponse,
    type PostOffersRemindResponses,
    type PostOffersRequestDocumentsData,
    type PostOffersRequestDocumentsError,
    type PostOffersRequestDocumentsErrors,
    type PostOffersRequestDocumentsResponse,
    type PostOffersRequestDocumentsResponses,
    type PostOffersResponse,
    type PostOffersResponses,
    type PostOffersSendData,
    type PostOffersSendError,
    type PostOffersSendErrors,
    type PostOffersSendForApprovalData,
    type PostOffersSendForApprovalError,
    type PostOffersSendForApprovalErrors,
    type PostOffersSendForApprovalResponse,
    type PostOffersSendForApprovalResponses,
    type PostOffersSendResponse,
    type PostOffersSendResponses,
    type PostOffersUploadDocumentsIdData,
    type PostOffersUploadDocumentsIdError,
    type PostOffersUploadDocumentsIdErrors,
    type PostOffersUploadDocumentsIdResponse,
    type PostOffersUploadDocumentsIdResponses,
    type PostOnboardingCompleteCheckoutData,
    type PostOnboardingCompleteCheckoutError,
    type PostOnboardingCompleteCheckoutErrors,
    type PostOnboardingCompleteCheckoutResponse,
    type PostOnboardingCompleteCheckoutResponses,
    type PostOnboardingCompleteSignupData,
    type PostOnboardingCompleteSignupError,
    type PostOnboardingCompleteSignupErrors,
    type PostOnboardingCompleteSignupResponse,
    type PostOnboardingCompleteSignupResponses,
    type PostOnboardingSelectPlanData,
    type PostOnboardingSelectPlanError,
    type PostOnboardingSelectPlanErrors,
    type PostOnboardingSelectPlanResponse,
    type PostOnboardingSelectPlanResponses,
    type PostOnboardingSignupData,
    type PostOnboardingSignupError,
    type PostOnboardingSignupErrors,
    type PostOnboardingSignupResponse,
    type PostOnboardingSignupResponses,
    type PostOnboardingUploadLogoData,
    type PostOnboardingUploadLogoError,
    type PostOnboardingUploadLogoErrors,
    type PostOnboardingUploadLogoResponse,
    type PostOnboardingUploadLogoResponses,
    type PostOnboardingVerifyCodeData,
    type PostOnboardingVerifyCodeError,
    type PostOnboardingVerifyCodeErrors,
    type PostOnboardingVerifyCodeResponse,
    type PostOnboardingVerifyCodeResponses,
    type PostOnboardingVerifyStatusData,
    type PostOnboardingVerifyStatusError,
    type PostOnboardingVerifyStatusErrors,
    type PostOnboardingVerifyStatusResponse,
    type PostOnboardingVerifyStatusResponses,
    type PostPermissionsData,
    type PostPermissionsError,
    type PostPermissionsErrors,
    type PostPermissionsResponse,
    type PostPermissionsResponses,
    type PostReachOutData,
    type PostReachOutError,
    type PostReachOutErrors,
    type PostReachOutSlotBookingData,
    type PostReachOutSlotBookingError,
    type PostReachOutSlotBookingErrors,
    type PostRekognitionCreateSessionData,
    type PostRekognitionCreateSessionError,
    type PostRekognitionCreateSessionErrors,
    type PostReportsConfigCompanyIdData,
    type PostReportsConfigCompanyIdError,
    type PostReportsConfigCompanyIdErrors,
    type PostReportsConfigCompanyIdResponse,
    type PostReportsConfigCompanyIdResponses,
    type PostReportsExecuteData,
    type PostReportsExecuteError,
    type PostReportsExecuteErrors,
    type PostReportsExecuteResponse,
    type PostReportsExecuteResponses,
    type PostScreeningReportPdfData,
    type PostScreeningReportPdfError,
    type PostScreeningReportPdfErrors,
    type PostScreeningReportPdfResponse,
    type PostScreeningReportPdfResponses,
    type PostSendEmailData,
    type PostSendEmailError,
    type PostSendEmailErrors,
    type PostSettingsCommunicationTemplatesActivateDefaultData,
    type PostSettingsCommunicationTemplatesActivateDefaultError,
    type PostSettingsCommunicationTemplatesActivateDefaultErrors,
    type PostSettingsCommunicationTemplatesActivateDefaultResponse,
    type PostSettingsCommunicationTemplatesActivateDefaultResponses,
    type PostSettingsCommunicationTemplatesData,
    type PostSettingsCommunicationTemplatesError,
    type PostSettingsCommunicationTemplatesErrors,
    type PostSettingsCommunicationTemplatesPreviewData,
    type PostSettingsCommunicationTemplatesPreviewError,
    type PostSettingsCommunicationTemplatesPreviewErrors,
    type PostSettingsCommunicationTemplatesPreviewResponse,
    type PostSettingsCommunicationTemplatesPreviewResponses,
    type PostSettingsCommunicationTemplatesResponse,
    type PostSettingsCommunicationTemplatesResponses,
    type PostSourcingExtractData,
    type PostSourcingExtractError,
    type PostSourcingExtractErrors,
    type PostSourcingExtractResponse,
    type PostSourcingExtractResponses,
    type PostSourcingSourcedCandidatesData,
    type PostSourcingSourcedCandidatesError,
    type PostSourcingSourcedCandidatesErrors,
    type PostSourcingSourcedCandidatesResponse,
    type PostSourcingSourcedCandidatesResponses,
    type PostTemporalCandidateData,
    type PostTemporalCandidateError,
    type PostTemporalCandidateErrors,
    type PostTemporalCommunicationStatusData,
    type PostTemporalCommunicationStatusError,
    type PostTemporalCommunicationStatusErrors,
    type PostTemporalInterviewQualityReportData,
    type PostTemporalInterviewQualityReportError,
    type PostTemporalInterviewQualityReportErrors,
    type PostTemporalInterviewQualityReportResponse,
    type PostTemporalInterviewQualityReportResponses,
    type PostTemporalInterviewQualityRunsRunIdStatusData,
    type PostTemporalInterviewQualityRunsRunIdStatusError,
    type PostTemporalInterviewQualityRunsRunIdStatusErrors,
    type PostTemporalInterviewQualityRunsRunIdStatusResponse,
    type PostTemporalInterviewQualityRunsRunIdStatusResponses,
    type PostTemporalScreeningCallObjectiveEvaluationsData,
    type PostTemporalScreeningCallObjectiveEvaluationsError,
    type PostTemporalScreeningCallObjectiveEvaluationsErrors,
    type PostTemporalScreeningCallObjectiveEvaluationsResponse,
    type PostTemporalScreeningCallObjectiveEvaluationsResponses,
    type PostTemporalWorkshortsData,
    type PostTemporalWorkshortsError,
    type PostTemporalWorkshortsErrors,
    type PostTemporalWorkshortsResponse,
    type PostTemporalWorkshortsResponses,
    type PostWebhooksAzureEmailData,
    type PostWebhooksAzureEmailError,
    type PostWebhooksAzureEmailErrors,
    type PostWebhooksDailyData,
    type PostWebhooksDailyError,
    type PostWebhooksDailyErrors,
    type PostWebhooksGraphData,
    type PostWebhooksGraphError,
    type PostWebhooksGraphErrors,
    type PostWebhooksGraphResponse,
    type PostWebhooksGraphResponses,
    type PostWebhooksGraphTranscriptData,
    type PostWebhooksGraphTranscriptError,
    type PostWebhooksGraphTranscriptErrors,
    type PostWebhooksGraphTranscriptResponse,
    type PostWebhooksGraphTranscriptResponses,
    type PostWebhooksPlivoRecordingData,
    type PostWebhooksPlivoRecordingError,
    type PostWebhooksPlivoRecordingErrors,
    type PostWebhooksPlivoRecordingResponse,
    type PostWebhooksPlivoRecordingResponses,
    type PostWebhooksPlivoVoiceData,
    type PostWebhooksPlivoVoiceError,
    type PostWebhooksPlivoVoiceErrors,
    type PostWebhooksPlivoVoiceResponse,
    type PostWebhooksPlivoVoiceResponses,
    type PostWebhooksPlivoWhatsappData,
    type PostWebhooksPlivoWhatsappError,
    type PostWebhooksPlivoWhatsappErrors,
    type PostWebhooksResendEmailData,
    type PostWebhooksResendEmailError,
    type PostWebhooksResendEmailErrors,
    type PostWebhooksStripeData,
    type PostWebhooksStripeError,
    type PostWebhooksStripeErrors,
    type PostWebhooksStripeResponse,
    type PostWebhooksStripeResponses,
    type PostWebhooksTwilioRecordingData,
    type PostWebhooksTwilioRecordingError,
    type PostWebhooksTwilioRecordingErrors,
    type PostWebhooksTwilioRecordingResponse,
    type PostWebhooksTwilioRecordingResponses,
    type PostWebhooksTwilioVoiceData,
    type PostWebhooksTwilioVoiceError,
    type PostWebhooksTwilioVoiceErrors,
    type PostWebhooksTwilioVoiceResponse,
    type PostWebhooksTwilioVoiceResponses,
    type PostWebhooksTwilioWhatsappData,
    type PostWebhooksTwilioWhatsappError,
    type PostWebhooksTwilioWhatsappErrors,
    type PostWhatsappCompanySlugData,
    type PostWhatsappCompanySlugError,
    type PostWhatsappCompanySlugErrors,
    type PostWhatsappData,
    type PostWhatsappError,
    type PostWhatsappErrors,
    type PublicCareerCompanySlugParams,
    type PublicCareerConfigApiResponseSchema,
    type PublicCareerConfigErrorSchema,
    type PublicCareerConfigParamsSchema,
    type PublicCareerConfigPayloadSchema,
    type PublicCareerDepartmentSchema,
    type PublicCareerDepartmentsNotFoundSchema,
    type PublicCareerDepartmentsParams,
    type PublicCareerDepartmentsResponseSchema,
    type PublicCareerErrorSchema,
    type PublicCareerJobApplicationApiResponseSchema,
    type PublicCareerJobApplicationBodySchema,
    type PublicCareerJobApplicationErrorSchema,
    type PublicCareerJobApplicationParamsSchema,
    type PublicCareerJobApplicationPayloadSchema,
    type PublicCareerJobDetailSchema,
    type PublicCareerJobIdParams,
    type PublicCareerJobNotFoundSchema,
    type PublicCareerJobsListResponseSchema,
    type PublicCareerJobsQueryParamsSchema,
    type PublicCareerJobUploadUrlErrorSchema,
    type PublicCareerJobUploadUrlParamsSchema,
    type PublicCareerJobUploadUrlQueryParamsSchema,
    type PublicCareerJobUploadUrlResponseSchema,
    type PublicCareerTalentPoolApplicationApiResponseSchema,
    type PublicCareerTalentPoolApplicationBodySchema,
    type PublicCareerTalentPoolApplicationErrorSchema,
    type PublicCareerTalentPoolApplicationParamsSchema,
    type PublicCareerTalentPoolApplicationPayloadSchema,
    type PublicCareerTalentPoolUploadUrlErrorSchema,
    type PublicCareerTalentPoolUploadUrlParamsSchema,
    type PublicCareerTalentPoolUploadUrlQueryParamsSchema,
    type PublicCareerTalentPoolUploadUrlResponseSchema,
    type PutAdminBillingCreditCostsIdData,
    type PutAdminBillingCreditCostsIdError,
    type PutAdminBillingCreditCostsIdErrors,
    type PutAdminBillingCreditCostsIdResponse,
    type PutAdminBillingCreditCostsIdResponses,
    type PutAdminCompaniesIdAccessControlData,
    type PutAdminCompaniesIdAccessControlError,
    type PutAdminCompaniesIdAccessControlErrors,
    type PutAdminCompaniesIdAccessControlResponse,
    type PutAdminCompaniesIdAccessControlResponses,
    type PutAdminCompaniesIdData,
    type PutAdminCompaniesIdError,
    type PutAdminCompaniesIdErrors,
    type PutAdminCompaniesIdResponse,
    type PutAdminCompaniesIdResponses,
    type PutAssessmentParamsIdData,
    type PutAssessmentParamsIdError,
    type PutAssessmentParamsIdErrors,
    type PutAssessmentParamsIdResponse,
    type PutAssessmentParamsIdResponses,
    type PutAssessmentTemplatesIdData,
    type PutAssessmentTemplatesIdError,
    type PutAssessmentTemplatesIdErrors,
    type PutAssessmentTemplatesIdResponse,
    type PutAssessmentTemplatesIdResponses,
    type PutAuthProfileData,
    type PutAuthProfileError,
    type PutAuthProfileErrors,
    type PutAuthProfileMultipartSchema,
    type PutAuthProfileResponse,
    type PutAuthProfileResponses,
    type PutBodySchema,
    type PutCalendarData,
    type PutCalendarError,
    type PutCalendarErrors,
    type PutCandidateSharingSharingSlugFeedbackData,
    type PutCandidateSharingSharingSlugFeedbackError,
    type PutCandidateSharingSharingSlugFeedbackErrors,
    type PutCandidatesIdData,
    type PutCandidatesIdError,
    type PutCandidatesIdErrors,
    type PutCompanyCompanySlugAccessControlConfigData,
    type PutCompanyCompanySlugAccessControlConfigError,
    type PutCompanyCompanySlugAccessControlConfigErrors,
    type PutCompanyCompanySlugAccessControlConfigResponse,
    type PutCompanyCompanySlugAccessControlConfigResponses,
    type PutCompanyCompanySlugCandidateStatusesConfigData,
    type PutCompanyCompanySlugCandidateStatusesConfigError,
    type PutCompanyCompanySlugCandidateStatusesConfigErrors,
    type PutCompanyCompanySlugCandidateStatusesConfigResponse,
    type PutCompanyCompanySlugCandidateStatusesConfigResponses,
    type PutCompanyCompanySlugJdTemplateData,
    type PutCompanyCompanySlugJdTemplateError,
    type PutCompanyCompanySlugJdTemplateErrors,
    type PutCompanyCompanySlugJdTemplateResponse,
    type PutCompanyCompanySlugJdTemplateResponses,
    type PutCompanyCompanySlugJobPostingConfigData,
    type PutCompanyCompanySlugJobPostingConfigError,
    type PutCompanyCompanySlugJobPostingConfigErrors,
    type PutCompanyCompanySlugJobPostingConfigResponse,
    type PutCompanyCompanySlugJobPostingConfigResponses,
    type PutCompanyConfigData,
    type PutCompanyConfigError,
    type PutCompanyConfigErrors,
    type PutCompanyConfigResponse,
    type PutCompanyConfigResponses,
    type PutGenerateQuestionsIdData,
    type PutGenerateQuestionsIdError,
    type PutGenerateQuestionsIdErrors,
    type PutHiringManagersIdData,
    type PutHiringManagersIdError,
    type PutHiringManagersIdErrors,
    type PutInterviewsFeedbackData,
    type PutInterviewsFeedbackError,
    type PutInterviewsFeedbackErrors,
    type PutInterviewsIdData,
    type PutInterviewsIdError,
    type PutInterviewsIdErrors,
    type PutInterviewsIdInterviewRoundData,
    type PutInterviewsIdInterviewRoundError,
    type PutInterviewsIdInterviewRoundErrors,
    type PutInterviewsIdInterviewRoundInterviewRoundIdData,
    type PutInterviewsIdInterviewRoundInterviewRoundIdError,
    type PutInterviewsIdInterviewRoundInterviewRoundIdErrors,
    type PutInterviewsIdInterviewRoundResponse,
    type PutInterviewsIdInterviewRoundResponses,
    type PutInterviewsIdResponse,
    type PutInterviewsIdResponses,
    type PutInterviewsScreeningCallData,
    type PutInterviewsScreeningCallError,
    type PutInterviewsScreeningCallErrors,
    type PutInterviewsScreeningInterviewData,
    type PutInterviewsScreeningInterviewError,
    type PutInterviewsScreeningInterviewErrors,
    type PutInterviewsScreeningWebrtcNetworkProbeData,
    type PutInterviewsScreeningWebrtcNetworkProbeError,
    type PutInterviewsScreeningWebrtcNetworkProbeErrors,
    type PutJdTemplateSchema,
    type PutJobApplicationsApproveData,
    type PutJobApplicationsApproveError,
    type PutJobApplicationsApproveErrors,
    type PutJobApplicationsApproveResponse,
    type PutJobApplicationsApproveResponses,
    type PutJobApplicationsIdData,
    type PutJobApplicationsIdError,
    type PutJobApplicationsIdErrors,
    type PutJobApplicationsIdResponse,
    type PutJobApplicationsIdResponses,
    type PutJobApproversApproveData,
    type PutJobApproversApproveError,
    type PutJobApproversApproveErrors,
    type PutJobApproversApproveResponse,
    type PutJobApproversApproveResponses,
    type PutJobsIdData,
    type PutJobsIdError,
    type PutJobsIdErrors,
    type PutJobsIdResponse,
    type PutJobsIdResponses,
    type PutNotesIdData,
    type PutNotesIdError,
    type PutNotesIdErrors,
    type PutNotificationsData,
    type PutNotificationsError,
    type PutNotificationsErrors,
    type PutNotificationsResponse,
    type PutNotificationsResponses,
    type PutOffersAcceptData,
    type PutOffersAcceptError,
    type PutOffersAcceptErrors,
    type PutOffersAcceptResponse,
    type PutOffersAcceptResponses,
    type PutOffersApproveData,
    type PutOffersApproveError,
    type PutOffersApproveErrors,
    type PutOffersApproveResponse,
    type PutOffersApproveResponses,
    type PutOffersData,
    type PutOffersDocumentsData,
    type PutOffersDocumentsError,
    type PutOffersDocumentsErrors,
    type PutOffersDocumentsResponse,
    type PutOffersDocumentsResponses,
    type PutOffersError,
    type PutOffersErrors,
    type PutOffersResponse,
    type PutOffersResponses,
    type PutOffersUploadDocumentsIdData,
    type PutOffersUploadDocumentsIdError,
    type PutOffersUploadDocumentsIdErrors,
    type PutOffersUploadDocumentsIdResponse,
    type PutOffersUploadDocumentsIdResponses,
    type PutSettingsCommunicationTemplatesIdData,
    type PutSettingsCommunicationTemplatesIdError,
    type PutSettingsCommunicationTemplatesIdErrors,
    type PutSettingsCommunicationTemplatesIdResponse,
    type PutSettingsCommunicationTemplatesIdResponses,
    type PutTemporalJobApplicationsIdData,
    type PutTemporalJobApplicationsIdError,
    type PutTemporalJobApplicationsIdErrors,
    type PutTemporalJobApplicationsIdResponse,
    type PutTemporalJobApplicationsIdResponses,
    type PutTemporalScreeningCallData,
    type PutTemporalScreeningCallError,
    type PutTemporalScreeningCallErrors,
    type PutTemporalScreeningCallResponse,
    type PutTemporalScreeningCallResponses,
    type ReachOutSchema,
    type ReencryptPayloadSchema,
    type ReferenceJdSchema,
    type ReportConfigSchema,
    type ReportPageSchema,
    type RequiredJobDescriptionIdSchema,
    type RequiredJobDescriptionUrlSchema,
    type ResetPasswordBodySchema,
    type Scalar,
    type Schema,
    type ScreeningCallLifecycleBodySchema,
    type ScreeningCallObjectiveEvaluationsApiResponseSchema,
    type ScreeningCallObjectiveEvaluationsBodySchema,
    type ScreeningCallObjectiveEvaluationsPayloadSchema,
    type ScreeningCallRecordingApiResponseSchema,
    type ScreeningCallRecordingFetchApiResponseSchema,
    type ScreeningCallRecordingFetchParamsSchema,
    type ScreeningCallRecordingFetchPayloadSchema,
    type ScreeningCallRecordingParamsSchema,
    type ScreeningCallRecordingPayloadSchema,
    type ScreeningConfigSchema,
    ScreeningInterviewVariantSchema,
    type ScreeningReportChartImageSchema,
    type ScreeningReportChartImagesSchema,
    type ScreeningReportPdfRequestSchema,
    type ScreeningReportPdfResponseSchema,
    type SelectableRoleSchema,
    type SetCompanyApiResponseSchema,
    type SetCompanyBodySchema,
    type SetCompanyPayloadSchema,
    type SeverityCountsSchema,
    SeveritySchema,
    type ShortlistRuleSchema,
    type SortModelParam,
    type SourcedCandidateNoteApiResponseSchema,
    type SourcedCandidateNoteBodySchema,
    type SourcedCandidateNoteDeleteApiResponseSchema,
    type SourcedCandidateNoteParamsSchema,
    type SourcedCandidateNotesApiResponseSchema,
    type SourcedCandidateNoteSchema,
    type SourcedInviteLinkSchema,
    type SourcingExtractApiResponseSchema,
    type SourcingExtractBodySchema,
    type SourcingJobsApiResponseSchema,
    type SourcingMatchSchema,
    type SourcingPageUrlSchema,
    type SourcingProfileSchema,
    type SourcingSourcedCandidateApiResponseSchema,
    type SourcingSourcedCandidateBodySchema,
    type StatusDefinitionSchema,
    type StorageAccessErrorMessageSchema,
    type StorageAccessQueryParamsSchema,
    type StorageAccessResponseSchema,
    type StorageUploadCredentialResponseSchema,
    type StorageUploadErrorMessageSchema,
    type StorageUploadQueryParamsSchema,
    type TalentPoolSchema,
    type TemporalCompanyAgentMemoryFlagsParamsSchema,
    type TemporalCompanyAgentMemoryFlagsResponseSchema,
    type TemporalInterviewQualityCheckQueryParamsSchema,
    type TemporalInterviewQualityCheckResponseSchema,
    type TemporalInterviewQualityContextQueryParamsSchema,
    type TemporalInterviewQualityContextResponseSchema,
    type TemporalInterviewQualityReportBodySchema,
    type TemporalInterviewQualityReportResponseSchema,
    type TemporalInterviewQualityRunStatusBodySchema,
    type TemporalInterviewQualityRunStatusParamsSchema,
    type TemporalInterviewQualityRunStatusResponseSchema,
    type Text,
    type UpdateAssessmentParamBodySchema,
    type UpdateAssessmentTemplateBodySchema,
    type UpdateDepartmentBodySchema,
    type UpdateJobApplicationSchema,
    type UpdateJobDescriptionBodySchema,
    type UpdateJobSchema,
    type UpdateRoutingRuleSchema,
    type UpdateStatusSchema,
    type Value,
    type Weird,
    type WidgetConfigSchema,
    type WithTrim,
    type ZodFormattedError,
} from './types.gen'
